export default {
  type: "Feature",
  properties: {
    name: "Хан-Уул",
    location: [47.79417, 106.7825],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [106.925690594345, 47.9082425992166],
        [106.927405182403, 47.908210327045],
        [106.930639418774, 47.9081862378047],
        [106.932621698133, 47.9081390090081],
        [106.93263807119, 47.9080723854323],
        [106.93266025117, 47.908006782587],
        [106.932689361325, 47.9079404836664],
        [106.932727629277, 47.9078691512404],
        [106.932768686026, 47.9078034611609],
        [106.932795855444, 47.9077542547551],
        [106.932803112074, 47.907731819368],
        [106.932808532288, 47.9077052920657],
        [106.932811186187, 47.9076467488984],
        [106.932818298925, 47.907448383636],
        [106.932816839326, 47.9072794118155],
        [106.932811152912, 47.9071267608913],
        [106.932812717733, 47.9070389870596],
        [106.932815635134, 47.9069700864004],
        [106.932813677309, 47.9069349732704],
        [106.932807677932, 47.9069039565524],
        [106.932796523641, 47.9068637631522],
        [106.932774903939, 47.9068023790266],
        [106.932759494955, 47.9067740926503],
        [106.932733718586, 47.9067348228538],
        [106.932699219693, 47.9066831487084],
        [106.932672729263, 47.906654602428],
        [106.932651321801, 47.9066379074135],
        [106.932628044649, 47.9066228545611],
        [106.932587874631, 47.9066029004036],
        [106.932539644889, 47.9065853438386],
        [106.932461631399, 47.9065671577481],
        [106.932359343409, 47.9065461306994],
        [106.932304625958, 47.9065383083962],
        [106.932242805661, 47.9065318422707],
        [106.93218335238, 47.9065280318433],
        [106.932083038402, 47.906524780794],
        [106.931923388953, 47.9065209685679],
        [106.931831471945, 47.9065214326181],
        [106.931754321805, 47.9065238140229],
        [106.931672357593, 47.9065288637161],
        [106.931590448241, 47.9065363217939],
        [106.93146822318, 47.9065539143317],
        [106.931426936204, 47.9065585719206],
        [106.931379725394, 47.9065613391346],
        [106.931272480341, 47.9065644211112],
        [106.931098823052, 47.9065738424089],
        [106.930919536907, 47.9065799407118],
        [106.930794500566, 47.9065789622493],
        [106.930668545117, 47.9065713297032],
        [106.930592612659, 47.9065631557651],
        [106.930508293123, 47.9065512757209],
        [106.930347677803, 47.9065214766849],
        [106.930276139432, 47.9065124106193],
        [106.930216650178, 47.9065074310731],
        [106.930167488739, 47.9065059651782],
        [106.930086106389, 47.906506375269],
        [106.92995085195, 47.9065086496545],
        [106.929757510301, 47.9065086496545],
        [106.929667747169, 47.906505157587],
        [106.929520211589, 47.9064963891971],
        [106.929302744726, 47.9064803003256],
        [106.929214924129, 47.9064755222276],
        [106.929031124287, 47.9064721101998],
        [106.928886087023, 47.906471298112],
        [106.928746245143, 47.9064801474409],
        [106.928669059929, 47.9064823795582],
        [106.928591668771, 47.906482744683],
        [106.92840774662, 47.9064760843039],
        [106.928124962897, 47.9064642033604],
        [106.927842373427, 47.906450340311],
        [106.92755997821, 47.9064344942565],
        [106.927277778147, 47.9064166669956],
        [106.92757244821, 47.9060942339618],
        [106.927701181664, 47.9058789515524],
        [106.927816872251, 47.9056471728788],
        [106.927941878915, 47.9053316619267],
        [106.928027914357, 47.9049708368347],
        [106.928165355047, 47.9041536561663],
        [106.928227043144, 47.9038526926477],
        [106.928338970068, 47.9033066153081],
        [106.928403724852, 47.9030422613913],
        [106.928556829034, 47.902646878051],
        [106.928837251138, 47.9021657794272],
        [106.929270138007, 47.901606899339],
        [106.929782355871, 47.9010090723109],
        [106.931312107168, 47.8991989807484],
        [106.932773022557, 47.8974674863355],
        [106.934490357144, 47.8954388316368],
        [106.936626213729, 47.8928955120183],
        [106.937567109634, 47.8918014921452],
        [106.937904679158, 47.8913570148144],
        [106.938162612814, 47.890943133319],
        [106.938405940582, 47.8904709928421],
        [106.938644588277, 47.889873567811],
        [106.939026867596, 47.8886408302102],
        [106.939250000187, 47.8877499995629],
        [106.939774510885, 47.8861176599021],
        [106.951750000162, 47.8765833326547],
        [106.956222222578, 47.8635555547451],
        [106.947111110889, 47.8465000002748],
        [106.92194444498, 47.812333333017],
        [106.945861110802, 47.7995000002249],
        [106.941388889286, 47.7859444443807],
        [106.946805556331, 47.7608055558318],
        [106.905888888961, 47.7488888894108],
        [106.889583333104, 47.7582222217782],
        [106.861472222065, 47.7624999999751],
        [106.8399999999, 47.7464722222153],
        [106.813277778447, 47.7205000002748],
        [106.797833333342, 47.7050000004497],
        [106.788694444293, 47.7235833331044],
        [106.731777778322, 47.7201388891984],
        [106.696277777098, 47.7291388887488],
        [106.683694444143, 47.7358611106018],
        [106.642833334191, 47.7421388892984],
        [106.60102777781, 47.74700000015],
        [106.589416666846, 47.7513611113263],
        [106.58602777766, 47.7501666668583],
        [106.581083333829, 47.7519999996003],
        [106.578027778359, 47.7499166670206],
        [106.59288888991, 47.7365555562939],
        [106.561388888786, 47.711333332967],
        [106.509444444905, 47.7191111106893],
        [106.507944444081, 47.7460555546202],
        [106.503333333067, 47.8054722216657],
        [106.539722223302, 47.8476388891235],
        [106.613472223065, 47.851277778147],
        [106.650194445218, 47.8743333332168],
        [106.675666666583, 47.873333332967],
        [106.697888888262, 47.8650277782094],
        [106.697897344587, 47.865117710414],
        [106.69791792827, 47.8652204633537],
        [106.697933941598, 47.865284555338],
        [106.697949186906, 47.865334940755],
        [106.697967159857, 47.8653841138858],
        [106.697984009554, 47.8654206533405],
        [106.698014874287, 47.8654744336982],
        [106.698047399168, 47.8655263065938],
        [106.698079195598, 47.8655725560287],
        [106.698122793832, 47.8656295982274],
        [106.698146708604, 47.8656540310088],
        [106.698179182224, 47.8656814180631],
        [106.698215844885, 47.8657080487875],
        [106.698260977362, 47.8657370105547],
        [106.698302017924, 47.8657603443644],
        [106.698342671777, 47.8657807337939],
        [106.698390300772, 47.8658018579694],
        [106.698446960759, 47.8658243266314],
        [106.698507510313, 47.8658461981436],
        [106.698566620054, 47.8658654085618],
        [106.698626123697, 47.8658826000021],
        [106.69868623708, 47.8658978399134],
        [106.69877868289, 47.8659170530296],
        [106.698897373615, 47.8659342777448],
        [106.699079585255, 47.8659534063247],
        [106.699258845319, 47.8659678242557],
        [106.69939043592, 47.8659828294441],
        [106.699533173617, 47.8660043772003],
        [106.699667933428, 47.8660288711355],
        [106.699754333096, 47.8660471480575],
        [106.699841909976, 47.8660676930696],
        [106.699928299751, 47.8660900061489],
        [106.700010048125, 47.8661131511011],
        [106.700148068878, 47.8661547123701],
        [106.700210658995, 47.8661751278799],
        [106.70027683291, 47.8661998610348],
        [106.700335602706, 47.8662267417708],
        [106.700394505602, 47.8662585570868],
        [106.700446194137, 47.8662920703229],
        [106.700481827075, 47.866321565388],
        [106.70051616319, 47.866357921381],
        [106.700550173752, 47.8663981786331],
        [106.700590184589, 47.8664506252962],
        [106.700633548999, 47.8665123151913],
        [106.700682367797, 47.8665879742556],
        [106.700775256973, 47.8667418446605],
        [106.7008131598, 47.866800838388],
        [106.700878691598, 47.8668935755781],
        [106.700929461026, 47.8669535270836],
        [106.70099172199, 47.8670187621062],
        [106.701046721829, 47.8670685692591],
        [106.701105106715, 47.8671133563963],
        [106.701179811599, 47.8671616868624],
        [106.701219450118, 47.8671841681149],
        [106.701254714334, 47.867201928826],
        [106.701327976705, 47.8672332962797],
        [106.701399550149, 47.8672614972204],
        [106.70150150629, 47.8672990214328],
        [106.701584726854, 47.867328664886],
        [106.701641492961, 47.8673465497035],
        [106.701711727314, 47.8673660748845],
        [106.701872885825, 47.8674057152016],
        [106.701943505988, 47.8674262287375],
        [106.702004632008, 47.8674468402995],
        [106.702050733055, 47.8674678772408],
        [106.702083764254, 47.8674863807919],
        [106.702121738128, 47.8675108522441],
        [106.702182481037, 47.8675543659413],
        [106.702236420574, 47.867595982069],
        [106.702301131292, 47.8676508119354],
        [106.702392082429, 47.8677405166116],
        [106.702441272647, 47.8677845258352],
        [106.702529691292, 47.8678571658755],
        [106.702595939851, 47.8679052238471],
        [106.702649861402, 47.8679377208492],
        [106.702711273407, 47.8679665450201],
        [106.702784713844, 47.8679942666221],
        [106.702860973655, 47.868017014074],
        [106.702915694704, 47.8680294813755],
        [106.702981284059, 47.8680410169794],
        [106.703063108875, 47.8680521955524],
        [106.703147635255, 47.868060937862],
        [106.703225512048, 47.8680659956493],
        [106.703308201113, 47.8680687080045],
        [106.703379957119, 47.8680691819472],
        [106.703455158429, 47.8680671782577],
        [106.703534770014, 47.8680632320326],
        [106.703694206323, 47.8680517710724],
        [106.703855639127, 47.868042962213],
        [106.703971602208, 47.8680321415701],
        [106.704037902028, 47.8680218659164],
        [106.704108401681, 47.8680069515596],
        [106.70418275583, 47.8679877816109],
        [106.704268178833, 47.8679622867302],
        [106.704377191954, 47.8679238398134],
        [106.704487801371, 47.8678762306036],
        [106.704667672975, 47.8677932231787],
        [106.704837891256, 47.8677075249823],
        [106.704890943163, 47.867679218821],
        [106.704931882101, 47.8676541502189],
        [106.704979055139, 47.8676190919476],
        [106.705025225434, 47.867575473929],
        [106.705072598122, 47.8675263187846],
        [106.705200292859, 47.867383560403],
        [106.705263366811, 47.8673199333683],
        [106.705300667991, 47.8672863212068],
        [106.705327422822, 47.8672650540391],
        [106.705364393952, 47.8672393855892],
        [106.705405335588, 47.8672144788652],
        [106.705450397918, 47.8671896234025],
        [106.705494021332, 47.8671682968795],
        [106.705535075383, 47.8671508302467],
        [106.705578959601, 47.8671348573878],
        [106.705628749667, 47.8671196408588],
        [106.705680386041, 47.8671064936698],
        [106.705730927041, 47.8670963394246],
        [106.705779272795, 47.8670892896391],
        [106.705839476111, 47.8670848379949],
        [106.705903863972, 47.8670855646471],
        [106.70596105366, 47.8670890000574],
        [106.706114227989, 47.867101830685],
        [106.706191192869, 47.8671098814159],
        [106.706275034865, 47.8671210617876],
        [106.706343950813, 47.8671327520749],
        [106.706410449383, 47.8671464892192],
        [106.706522337636, 47.8671736847178],
        [106.706710314829, 47.8672246996602],
        [106.706820166118, 47.8672556111576],
        [106.706938112204, 47.8672909581112],
        [106.707069596685, 47.8673326947481],
        [106.707199439902, 47.867376157184],
        [106.707332760798, 47.8674228499846],
        [106.707462324327, 47.8674705005632],
        [106.707640952168, 47.867540949855],
        [106.70780294525, 47.8676110969746],
        [106.707958592715, 47.8676855878197],
        [106.708124846784, 47.8677723759944],
        [106.708336986063, 47.8678919696387],
        [106.708544429982, 47.8680157613184],
        [106.708736545855, 47.8681364647261],
        [106.708920500381, 47.8682597159132],
        [106.709071262729, 47.8683659843028],
        [106.709244869655, 47.8684934137401],
        [106.709365117107, 47.8685853163593],
        [106.709484634308, 47.8686815501135],
        [106.709572167122, 47.8687570302128],
        [106.709657965143, 47.8688344519484],
        [106.709953031807, 47.8691129423085],
        [106.710105285231, 47.8692531097433],
        [106.710220454211, 47.8693528265717],
        [106.710364318758, 47.8694685261516],
        [106.710475379635, 47.8695544329908],
        [106.710590546816, 47.8696406438007],
        [106.710789231338, 47.8697830928155],
        [106.710930933916, 47.869879464166],
        [106.711053137392, 47.8699601270583],
        [106.711179679199, 47.8700408753862],
        [106.711288605085, 47.8701066931694],
        [106.711366915351, 47.8701514668168],
        [106.711452356341, 47.8701976002391],
        [106.711519302774, 47.8702315100762],
        [106.711609406749, 47.8702743924493],
        [106.71183971593, 47.8703822760213],
        [106.712002123599, 47.870454059907],
        [106.712088921666, 47.8704902135526],
        [106.712197868237, 47.8705311785711],
        [106.712297496932, 47.8705653609027],
        [106.712398646381, 47.8705968065974],
        [106.712509100215, 47.8706280085758],
        [106.712604270071, 47.8706519539246],
        [106.712695315636, 47.8706714602197],
        [106.712801531865, 47.8706909377366],
        [106.712900442901, 47.8707059923877],
        [106.712982916129, 47.870715239217],
        [106.713044317341, 47.8707194534401],
        [106.713111424753, 47.8707211603533],
        [106.713177765042, 47.8707202637292],
        [106.713249184702, 47.8707168382116],
        [106.713308950048, 47.8707114027091],
        [106.713359628644, 47.8707043619168],
        [106.713407313397, 47.8706951681476],
        [106.713453621288, 47.8706831289233],
        [106.713506008595, 47.8706660633882],
        [106.713563468979, 47.8706431999238],
        [106.713617559603, 47.8706180998455],
        [106.7136788484, 47.8705863546766],
        [106.713730606183, 47.8705563407026],
        [106.713778653362, 47.8705251899856],
        [106.713819441214, 47.870495090576],
        [106.713865107888, 47.8704576311148],
        [106.713908893181, 47.8704185591692],
        [106.713956455626, 47.8703727000401],
        [106.71403616164, 47.8702880486546],
        [106.714102384118, 47.8702039656405],
        [106.714165044381, 47.8701121538529],
        [106.714229861219, 47.8700108056542],
        [106.714293266121, 47.8699046343914],
        [106.71433956412, 47.8698222250157],
        [106.714382484264, 47.8697394837902],
        [106.714415565826, 47.8696707504049],
        [106.714437932864, 47.8696176841089],
        [106.714458237758, 47.8695633884397],
        [106.714491882295, 47.8694602550868],
        [106.714514641438, 47.8694029547826],
        [106.714538838597, 47.8693511160612],
        [106.714571833823, 47.8692927779394],
        [106.714638597693, 47.869191142857],
        [106.714722410011, 47.8690796871779],
        [106.714836405376, 47.8689406663787],
        [106.714935041219, 47.8688299796199],
        [106.715056798632, 47.8687056492464],
        [106.715123221659, 47.8686424808658],
        [106.715186567206, 47.8685852668966],
        [106.715309645724, 47.8684823107101],
        [106.715449501993, 47.8683766466649],
        [106.71553864819, 47.868313507962],
        [106.715661093585, 47.868230410605],
        [106.715893198712, 47.8680797498806],
        [106.716093689073, 47.8679563539027],
        [106.716316596834, 47.8678281258674],
        [106.716560762769, 47.8676954371947],
        [106.716757207979, 47.8675917480608],
        [106.716975427574, 47.8674793013287],
        [106.717135606723, 47.867398276909],
        [106.71726487977, 47.8673381374451],
        [106.717401877095, 47.8672823515993],
        [106.717474752758, 47.8672559286182],
        [106.717559298923, 47.8672275181355],
        [106.717731887816, 47.8671753079941],
        [106.717934547342, 47.8671213639598],
        [106.718092997094, 47.8670823810471],
        [106.718255521675, 47.8670451572083],
        [106.718393742078, 47.8670155955933],
        [106.718501234444, 47.8669950757622],
        [106.718598375615, 47.8669789383274],
        [106.718699040328, 47.8669653558665],
        [106.718812821654, 47.8669527941362],
        [106.71892961481, 47.8669427666954],
        [106.719023552595, 47.8669368455591],
        [106.719121033709, 47.8669339011786],
        [106.719202607614, 47.866934670099],
        [106.719286320108, 47.8669387035584],
        [106.719380396388, 47.8669470789446],
        [106.719476506935, 47.8669591793227],
        [106.719567099242, 47.8669743445904],
        [106.719648992407, 47.8669917302841],
        [106.71974765523, 47.8670179311327],
        [106.719846151679, 47.8670498183944],
        [106.719932383173, 47.8670831112966],
        [106.720005606873, 47.8671172207831],
        [106.720063811895, 47.8671501323728],
        [106.720121115797, 47.8671892798614],
        [106.720179289343, 47.8672358485556],
        [106.720250143329, 47.8672996806358],
        [106.720285153037, 47.8673345158752],
        [106.72031259585, 47.8673652771859],
        [106.720339472988, 47.8673989756822],
        [106.720368657787, 47.8674398480706],
        [106.720423833893, 47.8675282891992],
        [106.720501096449, 47.8676639609231],
        [106.720563002181, 47.8677608520817],
        [106.720623842217, 47.8678500810164],
        [106.720791512718, 47.8680872547231],
        [106.720894580421, 47.8682461964049],
        [106.720944119576, 47.8683123280516],
        [106.720978281223, 47.8683506526605],
        [106.721023467659, 47.8683960684239],
        [106.721064176371, 47.8684325386308],
        [106.72110356128, 47.8684637280187],
        [106.721151115632, 47.8684970029344],
        [106.721204122572, 47.8685298012094],
        [106.721253966597, 47.8685571711766],
        [106.721306608413, 47.8685823818715],
        [106.721353508957, 47.8686016129741],
        [106.721395643994, 47.8686160174153],
        [106.72144087, 47.8686285359782],
        [106.721494325703, 47.8686401624136],
        [106.721589543223, 47.8686565507593],
        [106.721738963782, 47.8686790643874],
        [106.721889961752, 47.868696700992],
        [106.722209355977, 47.8687241294151],
        [106.722418853048, 47.8687466232581],
        [106.722502171638, 47.8687542620996],
        [106.722626156672, 47.8687626150027],
        [106.722694543818, 47.8687640916895],
        [106.722775970235, 47.868763154596],
        [106.722883947336, 47.8687593153902],
        [106.7230779338, 47.8687495352629],
        [106.723190580181, 47.8687470666239],
        [106.723289662988, 47.8687487231751],
        [106.723406942676, 47.8687557091088],
        [106.723508888025, 47.8687643902645],
        [106.723602539825, 47.8687741362174],
        [106.72369565563, 47.8687856907071],
        [106.723788187775, 47.8687991607527],
        [106.723874705253, 47.8688137090855],
        [106.723963462944, 47.8688306649033],
        [106.724053028225, 47.8688498267581],
        [106.72414330397, 47.8688710462618],
        [106.724253645389, 47.8688994288656],
        [106.72437894793, 47.8689344898349],
        [106.724492649216, 47.8689687917764],
        [106.72458746384, 47.8689997923066],
        [106.724669580936, 47.8690291272924],
        [106.724751602704, 47.869061480403],
        [106.724825704143, 47.8690941087062],
        [106.724899246203, 47.8691297272551],
        [106.725025902224, 47.8691971017649],
        [106.725171576207, 47.8692800048684],
        [106.725291588036, 47.8693512824358],
        [106.725392894866, 47.8694153870106],
        [106.725476585776, 47.8694724301086],
        [106.725556217146, 47.8695314409233],
        [106.725636717261, 47.8695964879876],
        [106.725715355779, 47.8696652726343],
        [106.725789163139, 47.8697349781867],
        [106.725858156429, 47.8698059176091],
        [106.725926147874, 47.8698822961311],
        [106.725994999969, 47.8699659303834],
        [106.726093699665, 47.8700943850479],
        [106.72616227387, 47.8701897563522],
        [106.726211985695, 47.8702673111875],
        [106.726251158364, 47.8703399341407],
        [106.726276914048, 47.8704007822703],
        [106.726302870281, 47.8704799630799],
        [106.726323800203, 47.8705533333697],
        [106.726370190832, 47.8707354218023],
        [106.726423210363, 47.8709208386258],
        [106.726470122598, 47.8710718581798],
        [106.726514273915, 47.871202535069],
        [106.726594976377, 47.8714257800757],
        [106.726633127417, 47.8715364659352],
        [106.726654024963, 47.8716045068426],
        [106.726673658962, 47.8716809627063],
        [106.72668127622, 47.871743637359],
        [106.726680239302, 47.871817156037],
        [106.726668941119, 47.8719157469142],
        [106.726651610284, 47.8720102170979],
        [106.726638353377, 47.8720610036125],
        [106.726613482626, 47.8721421962055],
        [106.72658743736, 47.8722210091923],
        [106.726503646626, 47.8724560263246],
        [106.726473203675, 47.8725522636761],
        [106.726444765314, 47.8726620601061],
        [106.726430556025, 47.8727302556968],
        [106.726420102306, 47.8727930508587],
        [106.726412930213, 47.872851236995],
        [106.726409457031, 47.8729016961564],
        [106.726408724083, 47.8729611125653],
        [106.72641098318, 47.8730182357031],
        [106.726416186658, 47.8730702452957],
        [106.726424258073, 47.8731208375567],
        [106.726435845838, 47.8731723956895],
        [106.726449529023, 47.8732189715784],
        [106.726463878605, 47.8732581298589],
        [106.726481120407, 47.8732956082058],
        [106.726501851579, 47.8733326737639],
        [106.726526844638, 47.8733709318231],
        [106.72655472632, 47.8734079901866],
        [106.726585352732, 47.8734437247481],
        [106.726619494594, 47.8734788189923],
        [106.726653479974, 47.873509496666],
        [106.726694046593, 47.8735414621688],
        [106.726744473379, 47.8735763010055],
        [106.726799527177, 47.8736107603284],
        [106.726892785074, 47.8736654292163],
        [106.726947680591, 47.8736953190838],
        [106.726992410172, 47.8737170736841],
        [106.72703395885, 47.8737344009219],
        [106.727078541841, 47.873750008656],
        [106.727126440633, 47.8737640245901],
        [106.727173036307, 47.8737755458049],
        [106.727220471947, 47.8737850363504],
        [106.72726698938, 47.8737920636528],
        [106.727305293305, 47.8737958965634],
        [106.727345867118, 47.8737977042007],
        [106.727434301952, 47.873795213978],
        [106.727494332597, 47.8737909017288],
        [106.727587740682, 47.8737814993168],
        [106.727719406825, 47.8737666191342],
        [106.72783762001, 47.8737507550933],
        [106.728088126166, 47.8737122533179],
        [106.728197666289, 47.8736968407367],
        [106.728342404079, 47.8736782850249],
        [106.728437287051, 47.873667757561],
        [106.728536704405, 47.8736589334131],
        [106.728654642398, 47.8736509627218],
        [106.728803275151, 47.8736423391227],
        [106.728915453885, 47.8736377831572],
        [106.728993455684, 47.8736360330765],
        [106.729041046907, 47.8736367750172],
        [106.729088814397, 47.8736401735552],
        [106.729136811215, 47.8736466369827],
        [106.729188497052, 47.8736563280771],
        [106.729252996429, 47.8736708800072],
        [106.729386519672, 47.8737048204211],
        [106.729515716277, 47.8737411773135],
        [106.729614239705, 47.8737730942529],
        [106.729713981715, 47.8738097218413],
        [106.729815993613, 47.8738514395923],
        [106.729898442559, 47.8738893352247],
        [106.729980451737, 47.8739329676324],
        [106.73006160386, 47.8739819546035],
        [106.730118343887, 47.8740212432858],
        [106.730162424157, 47.874058255784],
        [106.73020031799, 47.8740982072665],
        [106.730232811395, 47.8741404556176],
        [106.730262032167, 47.8741868300582],
        [106.730291177396, 47.8742431545979],
        [106.730303815569, 47.8742751461811],
        [106.730314959967, 47.8743144834267],
        [106.730327766313, 47.8744070938124],
        [106.730342605127, 47.874464914824],
        [106.730356525733, 47.8745021656425],
        [106.730375587763, 47.8745435218661],
        [106.730392762116, 47.874575901057],
        [106.730410504841, 47.8746040921052],
        [106.730430476985, 47.8746307372188],
        [106.730455245213, 47.8746587888721],
        [106.730484928237, 47.8746881400457],
        [106.730522492919, 47.8747216272014],
        [106.730571596802, 47.8747626731589],
        [106.73062090573, 47.8748009599964],
        [106.730666706403, 47.8748340568463],
        [106.730712908174, 47.8748644674213],
        [106.730789570882, 47.8749078992802],
        [106.730832920003, 47.8749284811645],
        [106.73087505414, 47.8749462400769],
        [106.730927123988, 47.8749660917118],
        [106.73100010577, 47.8749913779498],
        [106.731148156662, 47.8750382757958],
        [106.731286372568, 47.8750771328035],
        [106.731468087782, 47.8751250199038],
        [106.731626708406, 47.8751630477365],
        [106.731748847132, 47.8751894824088],
        [106.731862534029, 47.875207575869],
        [106.731958920668, 47.8752185413027],
        [106.732062013551, 47.8752269913326],
        [106.732170836015, 47.8752331543866],
        [106.732279630601, 47.8752363829528],
        [106.732385782078, 47.8752364117311],
        [106.732494457054, 47.8752338153883],
        [106.732619824345, 47.8752283358191],
        [106.732736085102, 47.8752206592061],
        [106.732940248294, 47.8752003030516],
        [106.733218637031, 47.8751653787793],
        [106.733393584846, 47.8751418066491],
        [106.733804521062, 47.8750820008337],
        [106.734157215383, 47.8750344698649],
        [106.734418724744, 47.8750019467824],
        [106.734571963825, 47.8749860062992],
        [106.734697901287, 47.8749758538526],
        [106.73483865508, 47.8749679128389],
        [106.734997030189, 47.8749625142087],
        [106.735116828879, 47.8749607713226],
        [106.73522436801, 47.8749616517589],
        [106.735305807017, 47.8749644756301],
        [106.735423407764, 47.8749713437526],
        [106.735769360767, 47.8749947081393],
        [106.736085261126, 47.8750209422627],
        [106.736197575658, 47.8750315776452],
        [106.736441252362, 47.87505956095],
        [106.736549993887, 47.8750694292108],
        [106.73665412189, 47.8750761012811],
        [106.736795373907, 47.875081605132],
        [106.736936116009, 47.8750832769717],
        [106.73705583376, 47.8750809917944],
        [106.73715882502, 47.875075076054],
        [106.737246455859, 47.8750671152552],
        [106.73734766916, 47.875055335935],
        [106.737424123225, 47.8750436177688],
        [106.737488431046, 47.875031035354],
        [106.737565742165, 47.8750123222609],
        [106.737637332697, 47.8749913437755],
        [106.737701719659, 47.8749687680942],
        [106.737760661226, 47.8749435358156],
        [106.737823244147, 47.8749113490795],
        [106.737905103138, 47.8748637119908],
        [106.738058451936, 47.8747699037082],
        [106.738162441444, 47.8747012638523],
        [106.738233657857, 47.8746497515848],
        [106.738307386976, 47.874591014164],
        [106.738384139616, 47.8745247170421],
        [106.738437436139, 47.8744739647017],
        [106.738470789296, 47.8744381438053],
        [106.73849914492, 47.8744034884303],
        [106.738522474233, 47.874369044396],
        [106.738541959844, 47.8743339177761],
        [106.738565633597, 47.8742798811117],
        [106.738612153728, 47.8741465341353],
        [106.738646703882, 47.874060825147],
        [106.73871382928, 47.8739047046385],
        [106.738802756942, 47.8737109493009],
        [106.738856095732, 47.8735986680442],
        [106.738901447644, 47.8735087808057],
        [106.738974780162, 47.8733717726892],
        [106.73904342991, 47.8732492841272],
        [106.739123860778, 47.8731173257041],
        [106.739184279031, 47.8730263296015],
        [106.739231495237, 47.8729631971938],
        [106.739265057936, 47.8729232735902],
        [106.739295455921, 47.872892672359],
        [106.739339540687, 47.8728542740056],
        [106.739384471716, 47.8728205925963],
        [106.739435414713, 47.8727884957925],
        [106.739492360684, 47.8727585177914],
        [106.739551534276, 47.8727324914114],
        [106.739610449762, 47.8727114256918],
        [106.739660411599, 47.8726974367374],
        [106.739714378116, 47.8726863876667],
        [106.739775148904, 47.8726776714374],
        [106.739860916348, 47.8726689588054],
        [106.739945402259, 47.8726630241793],
        [106.740027283732, 47.8726605564396],
        [106.740116125059, 47.8726613793192],
        [106.7401957951, 47.8726653228464],
        [106.740262987947, 47.8726714283438],
        [106.740342337829, 47.87268155471],
        [106.740430088278, 47.8726951623519],
        [106.740574779303, 47.8727200879617],
        [106.740690644358, 47.8727425620196],
        [106.740780530697, 47.872763459566],
        [106.740861759263, 47.8727866018203],
        [106.740932945099, 47.8728118143138],
        [106.741015118853, 47.8728463159048],
        [106.741146669883, 47.8729067647354],
        [106.741442750083, 47.8730384587579],
        [106.741555784972, 47.8730925538783],
        [106.741649375618, 47.873141316019],
        [106.741735214109, 47.8731907472553],
        [106.741815078403, 47.873241757701],
        [106.74190031165, 47.873301093171],
        [106.741991130586, 47.8733694596329],
        [106.742093846654, 47.8734522242408],
        [106.742205259165, 47.8735475379885],
        [106.742294388275, 47.8736288861642],
        [106.742375942396, 47.8737090454362],
        [106.742436375938, 47.8737720447441],
        [106.742485284668, 47.8738264186543],
        [106.742547027623, 47.8739014041266],
        [106.74258979938, 47.8739662317562],
        [106.742631583681, 47.8740474288458],
        [106.742676306067, 47.8741521207239],
        [106.74270153205, 47.8742214467624],
        [106.742727822831, 47.8743063868304],
        [106.742775991419, 47.8744820603988],
        [106.742844758978, 47.8747177628146],
        [106.742888413869, 47.8748530936954],
        [106.742925535185, 47.8749522871184],
        [106.742987492179, 47.875095922339],
        [106.743055358618, 47.8752355663684],
        [106.743119465891, 47.8753540115784],
        [106.743185314251, 47.8754715961373],
        [106.74323246031, 47.8755492543946],
        [106.74328461919, 47.8756272489984],
        [106.74334002732, 47.8756960129607],
        [106.743414864405, 47.875774254878],
        [106.74349747343, 47.8758492781217],
        [106.743551858132, 47.875895550939],
        [106.743594379877, 47.8759290551818],
        [106.743661254363, 47.8759761742611],
        [106.743695664224, 47.8759965340129],
        [106.743730785447, 47.8760144431121],
        [106.74376917211, 47.8760315751971],
        [106.743817635675, 47.8760506408245],
        [106.743923458901, 47.8760872926945],
        [106.744048900836, 47.8761265552964],
        [106.744158852849, 47.8761560467642],
        [106.744286551183, 47.876185889867],
        [106.744399601361, 47.8762087065666],
        [106.74451666791, 47.8762284224038],
        [106.744650797297, 47.8762480689932],
        [106.744833551227, 47.8762721069722],
        [106.745047089851, 47.8762968617108],
        [106.745327499365, 47.8763247856604],
        [106.745617075668, 47.876351615135],
        [106.745917128173, 47.8763770092916],
        [106.746179454119, 47.8763970929515],
        [106.746441988707, 47.8764149058233],
        [106.747007303444, 47.8764471087471],
        [106.747181637023, 47.8764597712016],
        [106.747350363329, 47.8764750452872],
        [106.747643847186, 47.8765072652981],
        [106.747826781881, 47.8765296961886],
        [106.74797533999, 47.8765498176201],
        [106.748087040285, 47.8765656906542],
        [106.748152626942, 47.8765767532146],
        [106.748284212147, 47.8766056007679],
        [106.748345896646, 47.876616564403],
        [106.748397624751, 47.8766232337752],
        [106.748466040675, 47.8766279669072],
        [106.748527808811, 47.8766291306299],
        [106.748583128808, 47.876626578354],
        [106.748634156341, 47.8766194818037],
        [106.748682027254, 47.8766082924388],
        [106.74874737739, 47.8765878922175],
        [106.74885121671, 47.8765504381523],
        [106.749025072749, 47.8764943168593],
        [106.749287413983, 47.8764043990438],
        [106.749387667707, 47.8763740936896],
        [106.749477133163, 47.8763513992977],
        [106.749607580725, 47.8763245698231],
        [106.749741079687, 47.8763019941418],
        [106.749872270089, 47.876284630931],
        [106.749999856908, 47.8762725818142],
        [106.750144945433, 47.8762651462196],
        [106.750285052613, 47.8762649852409],
        [106.750365184905, 47.8762674592759],
        [106.750459623613, 47.8762723506885],
        [106.750556057916, 47.8762789741954],
        [106.750649591905, 47.8762872173812],
        [106.75082503165, 47.8763077695879],
        [106.75101304032, 47.8763360172934],
        [106.751210430717, 47.8763714469848],
        [106.751392323997, 47.8764096555812],
        [106.751523726639, 47.8764409852633],
        [106.751650582309, 47.8764744058692],
        [106.751769811728, 47.8765089200507],
        [106.751888381044, 47.8765466547044],
        [106.752005753363, 47.8765873571209],
        [106.752130250111, 47.8766341443504],
        [106.752247939891, 47.8766816141652],
        [106.752378759772, 47.8767375825734],
        [106.752494022281, 47.8767901092762],
        [106.752607074257, 47.8768460776844],
        [106.752685204659, 47.8768869221938],
        [106.7529057499, 47.8770072640741],
        [106.753090697278, 47.8771009878204],
        [106.753242813105, 47.877175066776],
        [106.753432228315, 47.8772644827697],
        [106.753745710396, 47.8774078194154],
        [106.753930515681, 47.8774885056901],
        [106.754151744408, 47.8775801951699],
        [106.754407161761, 47.8776822844099],
        [106.754811392632, 47.8778410417307],
        [106.755085097699, 47.8779514838739],
        [106.755295922169, 47.8780403602744],
        [106.755492774772, 47.8781280522679],
        [106.755660683594, 47.8782079309513],
        [106.755842929408, 47.8782997121621],
        [106.756341903856, 47.8785635732503],
        [106.756524034557, 47.8786576828058],
        [106.756660377175, 47.8787254611112],
        [106.756782102212, 47.8787832839214],
        [106.756921552887, 47.8788457966962],
        [106.757068908603, 47.8789093625771],
        [106.757250254196, 47.8789848120995],
        [106.757455712411, 47.8790669831548],
        [106.757643175192, 47.8791368532832],
        [106.757866084752, 47.8792127560639],
        [106.758086426747, 47.8792821099814],
        [106.758243632738, 47.8793259357434],
        [106.758336040776, 47.8793488216908],
        [106.758441834323, 47.879372874059],
        [106.758531571375, 47.8793918650426],
        [106.758596301878, 47.8794039321458],
        [106.758656196726, 47.8794133606381],
        [106.758718453194, 47.8794209374264],
        [106.75878963993, 47.879426407103],
        [106.758865453678, 47.8794290780895],
        [106.758944905183, 47.8794292480614],
        [106.759063119268, 47.8794265545919],
        [106.759187362407, 47.8794214536372],
        [106.759270041579, 47.8794163418907],
        [106.759370933822, 47.8794076724262],
        [106.759478430685, 47.8793959173877],
        [106.759599789699, 47.8793800065821],
        [106.759754804041, 47.8793566080211],
        [106.759897680234, 47.8793329081872],
        [106.760071607319, 47.879301879778],
        [106.760210350228, 47.87927595682],
        [106.760336169878, 47.8792505563682],
        [106.760455080937, 47.8792248366569],
        [106.760567309134, 47.8791984937156],
        [106.760753411241, 47.8791495732942],
        [106.760925012679, 47.8790972759186],
        [106.761111933169, 47.8790324851611],
        [106.761289258792, 47.8789636150788],
        [106.761445843351, 47.8788958097939],
        [106.761592819553, 47.8788250106658],
        [106.761688193555, 47.8787761666868],
        [106.761781068342, 47.8787262399241],
        [106.761866287199, 47.8786782323146],
        [106.76193764031, 47.8786353868137],
        [106.762005993282, 47.8785910268544],
        [106.762069161663, 47.8785460301752],
        [106.762124023005, 47.8785026091082],
        [106.762175987632, 47.8784563371902],
        [106.762229854324, 47.8784021737214],
        [106.762278591284, 47.878347492243],
        [106.762325606042, 47.8782890497999],
        [106.762374046225, 47.8782224460091],
        [106.762425711378, 47.8781407497958],
        [106.762464869658, 47.8780635438975],
        [106.762501148309, 47.8779835599934],
        [106.762593262269, 47.8777610092632],
        [106.762633050075, 47.877675138397],
        [106.762686586717, 47.8775667566006],
        [106.762715374015, 47.8775131624026],
        [106.762747728025, 47.8774591329327],
        [106.762775517077, 47.8774188163254],
        [106.762804700976, 47.8773818748737],
        [106.76284993058, 47.8773314220076],
        [106.762904190276, 47.8772771182445],
        [106.762964694865, 47.8772210383203],
        [106.763025680591, 47.8771689729698],
        [106.763136523832, 47.8770844780662],
        [106.763263206832, 47.8769926330037],
        [106.763393350423, 47.8769031153865],
        [106.763486636199, 47.8768417582406],
        [106.763525640696, 47.8768192149349],
        [106.763565189282, 47.8767989909807],
        [106.763603042646, 47.8767819299422],
        [106.763644672264, 47.8767657844135],
        [106.763746364004, 47.8767329852391],
        [106.76389975417, 47.8766913520244],
        [106.763985914618, 47.876670577685],
        [106.76410146581, 47.8766468562675],
        [106.764302558716, 47.8766112916778],
        [106.76438584583, 47.8765952001084],
        [106.764571146641, 47.8765553007865],
        [106.764741072642, 47.8765156307918],
        [106.764820713006, 47.8764949670691],
        [106.764884206941, 47.8764759967699],
        [106.764958513425, 47.8764501061875],
        [106.765027344836, 47.8764229169841],
        [106.765100394967, 47.8763898713955],
        [106.765161827656, 47.8763569580073],
        [106.765226005975, 47.8763169022033],
        [106.76528703307, 47.8762727679739],
        [106.765321685747, 47.8762441722308],
        [106.765361532908, 47.8762061102238],
        [106.765478511324, 47.8760807744083],
        [106.765522674332, 47.8760371366046],
        [106.765575972653, 47.8759918296592],
        [106.765608757438, 47.8759682332474],
        [106.765644858923, 47.8759450433291],
        [106.76571382883, 47.8759070910395],
        [106.765742221326, 47.8758942298349],
        [106.76577571118, 47.8758813659323],
        [106.765852512384, 47.8758558746489],
        [106.765917242887, 47.8758372712731],
        [106.765992124037, 47.8758184097918],
        [106.766041050754, 47.8758017156767],
        [106.766058583037, 47.8757935327454],
        [106.766078478739, 47.8757817956933],
        [106.766115034381, 47.8757544563032],
        [106.766150051284, 47.8757219251268],
        [106.766176379836, 47.8756918562942],
        [106.76619611366, 47.8756606902887],
        [106.76621378264, 47.875621433982],
        [106.76623146511, 47.8755659566037],
        [106.766255054327, 47.8754758733129],
        [106.766292457131, 47.8753468062102],
        [106.766309065811, 47.8752732515593],
        [106.766321250725, 47.8751968766346],
        [106.766328821218, 47.8751215620105],
        [106.766330324885, 47.8750595969229],
        [106.76632893813, 47.8750282321672],
        [106.766324591707, 47.8750070873073],
        [106.766317793731, 47.8749909282888],
        [106.766302516948, 47.8749648092786],
        [106.766237108356, 47.8748759976293],
        [106.766210948876, 47.8748337258958],
        [106.766192650371, 47.8747916556105],
        [106.766186445048, 47.8747679800583],
        [106.766183425125, 47.874745775797],
        [106.766184578955, 47.8747110997375],
        [106.766195526402, 47.8746733147217],
        [106.766210119701, 47.8746372582029],
        [106.766231634183, 47.8745948021085],
        [106.766258776621, 47.8745491399309],
        [106.76627875596, 47.8745230011356],
        [106.766304421712, 47.8744957705634],
        [106.766333548954, 47.8744698655919],
        [106.766367213276, 47.8744437924471],
        [106.766411816053, 47.874413228088],
        [106.766454336898, 47.8743873402037],
        [106.766492149793, 47.8743670344111],
        [106.766542227642, 47.8743437365742],
        [106.766601754667, 47.874318871219],
        [106.766747504194, 47.8742617984433],
        [106.766896831224, 47.8742091710165],
        [106.766977620021, 47.8741838497049],
        [106.76706034326, 47.8741602568904],
        [106.767143127653, 47.8741389168775],
        [106.767228871715, 47.8741190490549],
        [106.767361088244, 47.8740925927989],
        [106.767496611579, 47.8740706376499],
        [106.767630624953, 47.8740540604466],
        [106.767762391821, 47.8740430023827],
        [106.767898139987, 47.8740367466985],
        [106.76803917257, 47.8740349255714],
        [106.768222793447, 47.8740380174406],
        [106.768375124213, 47.8740446112698],
        [106.768461394378, 47.8740508759472],
        [106.768542047378, 47.8740590858582],
        [106.768621749794, 47.8740701277343],
        [106.768687406599, 47.8740822640852],
        [106.768731198186, 47.8740922807342],
        [106.768792082289, 47.8741085197924],
        [106.768973188662, 47.8741644828047],
        [106.769107085124, 47.8742003567611],
        [106.769235687277, 47.8742299399598],
        [106.769352064047, 47.8742548071137],
        [106.769476096745, 47.8742791373724],
        [106.769583000055, 47.8742979961556],
        [106.769737327316, 47.8743214639645],
        [106.769919348299, 47.8743442419932],
        [106.770098273816, 47.874363331003],
        [106.770588762262, 47.8744120841504],
        [106.77073771967, 47.8744258986364],
        [106.770863024009, 47.8744343567602],
        [106.770978079675, 47.8744379828267],
        [106.771098803767, 47.8744371086857],
        [106.77125111115, 47.8744309672154],
        [106.77146354001, 47.8744169872542],
        [106.771627186945, 47.8744026979262],
        [106.771792683785, 47.8743834416426],
        [106.772018008924, 47.8743505282544],
        [106.772269120324, 47.8743068490818],
        [106.772551586587, 47.8742525552113],
        [106.772964840355, 47.8741713059611],
        [106.773259820684, 47.8741102653765],
        [106.773464542355, 47.8740656113389],
        [106.773675716661, 47.8740147888515],
        [106.773907504328, 47.8739545036975],
        [106.774086215806, 47.8739040337442],
        [106.77426652538, 47.8738473800526],
        [106.774455855154, 47.873779992053],
        [106.774641871825, 47.8737065947836],
        [106.774725819041, 47.87367038538],
        [106.77480419136, 47.873634082447],
        [106.774886605233, 47.8735921002952],
        [106.774964175356, 47.8735478077851],
        [106.775170288278, 47.8734193962882],
        [106.775428301975, 47.8732646310579],
        [106.775579388978, 47.8731774858524],
        [106.775661129258, 47.8731342662335],
        [106.775730098265, 47.873101237732],
        [106.775815397163, 47.8730646533111],
        [106.775901577396, 47.8730315016026],
        [106.776031408023, 47.8729866227345],
        [106.776149827153, 47.8729512101303],
        [106.776266088809, 47.8729222699468],
        [106.776375974272, 47.8729007347811],
        [106.776493030029, 47.8728839507338],
        [106.776628698156, 47.872870547238],
        [106.776791021289, 47.8728601681623],
        [106.776953768901, 47.8728544853463],
        [106.777034672812, 47.8728538522236],
        [106.777119006737, 47.8728550797982],
        [106.777193326711, 47.8728580691446],
        [106.777273194602, 47.8728631781932],
        [106.777355987989, 47.8728704123397],
        [106.777439452269, 47.8728796402832],
        [106.777515237238, 47.8728902738671],
        [106.777581708829, 47.8729018454439],
        [106.77765325979, 47.8729168119614],
        [106.777725021193, 47.8729343631304],
        [106.777797576697, 47.8729545628029],
        [106.777862971799, 47.8729754405642],
        [106.777919994212, 47.8729961672394],
        [106.777976227021, 47.8730194758681],
        [106.778025104275, 47.8730428258657],
        [106.778073976133, 47.873069313598],
        [106.778132336738, 47.8731048404161],
        [106.778206233131, 47.8731543678798],
        [106.778267176589, 47.8731990129241],
        [106.778313721901, 47.8732369400328],
        [106.778381864432, 47.873298113717],
        [106.778531695082, 47.8734442166773],
        [106.778731939028, 47.8736288843656],
        [106.778859369364, 47.8737492577221],
        [106.778967392331, 47.873856512668],
        [106.779065567722, 47.8739613295518],
        [106.779139322921, 47.874049752694],
        [106.779245662357, 47.874187753662],
        [106.779304174948, 47.87425658957],
        [106.779355767255, 47.874312576864],
        [106.779403919655, 47.8743607319623],
        [106.779473438149, 47.8744234875539],
        [106.779525507097, 47.8744618049684],
        [106.779585580011, 47.8745001457652],
        [106.77963791156, 47.8745278673672],
        [106.779687804149, 47.874548522996],
        [106.779753272096, 47.8745689555929],
        [106.779841109779, 47.8745902416464],
        [106.779936045812, 47.8746092919853],
        [106.780022318675, 47.8746222898868],
        [106.780111153707, 47.8746321707382],
        [106.78020261296, 47.8746397547209],
        [106.780289350773, 47.8746441326207],
        [106.780369430005, 47.8746453341149],
        [106.78044828526, 47.8746443646457],
        [106.78054972519, 47.8746408923633],
        [106.780857628777, 47.8746258008401],
        [106.780954867973, 47.8746195910214],
        [106.78105977299, 47.8746096256337],
        [106.781129649414, 47.8746064123561],
        [106.781208112564, 47.8746072271419],
        [106.781283017997, 47.8746108900806],
        [106.78145795592, 47.8746225488916],
        [106.78154250838, 47.8746257441828],
        [106.781618948056, 47.8746249213031],
        [106.781687735401, 47.8746197511007],
        [106.781762999663, 47.8746098279812],
        [106.781842354041, 47.8745964892366],
        [106.781926586343, 47.8745796062639],
        [106.782017755115, 47.8745587671734],
        [106.782152077856, 47.8745255758947],
        [106.782244812348, 47.8744991466183],
        [106.782324976117, 47.8744712208702],
        [106.782393277828, 47.8744412167888],
        [106.782415929052, 47.8744285048717],
        [106.782470993641, 47.8743932388569],
        [106.782504513173, 47.874377374816],
        [106.782530855215, 47.8743686990563],
        [106.782559690178, 47.8743560249107],
        [106.782631363447, 47.8743183729946],
        [106.78269657059, 47.8742868589514],
        [106.782743294867, 47.8742614719894],
        [106.782811012918, 47.874220708419],
        [106.782975078937, 47.8741157710261],
        [106.783126648876, 47.8740226057587],
        [106.783233930801, 47.8739619132118],
        [106.783276564962, 47.8739396073271],
        [106.783317054239, 47.8739206873898],
        [106.783355716993, 47.8739049276703],
        [106.783397432945, 47.8738903730423],
        [106.783493160381, 47.8738627395738],
        [106.78359903217, 47.8738391278735],
        [106.783702086382, 47.8738218626889],
        [106.783812935918, 47.8738095491714],
        [106.783936739289, 47.8738016207482],
        [106.784056092814, 47.8737995037442],
        [106.784177215306, 47.8738030587642],
        [106.784305554858, 47.8738055561815],
        [106.784415378267, 47.8738145871735],
        [106.784530554442, 47.8738209300919],
        [106.784644395123, 47.873831363127],
        [106.784756903009, 47.8738458880773],
        [106.784898619975, 47.8738685240132],
        [106.785009187124, 47.8738905277257],
        [106.785104826427, 47.8739151376735],
        [106.785187232205, 47.8739429357179],
        [106.785231441078, 47.8739616074423],
        [106.785275712005, 47.8739834124046],
        [106.785320398418, 47.8740085259727],
        [106.78536614693, 47.8740373087749],
        [106.785457370561, 47.8741026634072],
        [106.785599881629, 47.874215818805],
        [106.785649332651, 47.874257011352],
        [106.78569796439, 47.8743016707855],
        [106.785746295755, 47.8743502719475],
        [106.78579530431, 47.8744037924012],
        [106.785879467364, 47.8745044688063],
        [106.786063722263, 47.8747392323298],
        [106.786155276845, 47.8748455798597],
        [106.78624305967, 47.8749470737485],
        [106.786434097256, 47.8751843167029],
        [106.786482426823, 47.8752402554335],
        [106.786528217603, 47.8752898143735],
        [106.786589101706, 47.8753498971801],
        [106.786650191753, 47.8754033366947],
        [106.786712709924, 47.8754512013119],
        [106.786777325313, 47.8754939928535],
        [106.786844676441, 47.8755340162819],
        [106.786908529205, 47.8755692939878],
        [106.786970240684, 47.8756005697106],
        [106.787030362162, 47.8756281213407],
        [106.787121747671, 47.8756681034003],
        [106.787176142265, 47.875689448809],
        [106.787228422554, 47.8757059297849],
        [106.787277121742, 47.875716511208],
        [106.787312885981, 47.8757209547583],
        [106.787353847402, 47.8757233532502],
        [106.787490613601, 47.8757234350885],
        [106.78762462068, 47.8757249180705],
        [106.787666594738, 47.8757233856258],
        [106.787703753825, 47.8757201156908],
        [106.787736964889, 47.8757150273267],
        [106.787773353258, 47.8757071888357],
        [106.787930356901, 47.8756653460789],
        [106.788035999362, 47.8756414151193],
        [106.788096766553, 47.8756320100093],
        [106.788146429814, 47.875628898355],
        [106.788200577095, 47.8756289649049],
        [106.788259676043, 47.8756321988669],
        [106.788325483934, 47.8756386946701],
        [106.788384012712, 47.8756477508431],
        [106.788447816913, 47.8756619349504],
        [106.788514229148, 47.8756801012557],
        [106.788632790371, 47.8757158897765],
        [106.788695466822, 47.875735854726],
        [106.788763684896, 47.8757602218568],
        [106.788991448996, 47.8758501882356],
        [106.789080292122, 47.8758831331002],
        [106.789307281906, 47.8759614397687],
        [106.789465486143, 47.8760103529954],
        [106.789580900638, 47.8760426125766],
        [106.789667120441, 47.8760649589308],
        [106.789745882167, 47.8760830254113],
        [106.789818822581, 47.8760970773183],
        [106.789928511092, 47.8761153974077],
        [106.790006118987, 47.8761258592211],
        [106.790076349744, 47.8761318019411],
        [106.790139948, 47.876133060992],
        [106.790187606673, 47.8761307047683],
        [106.790240709841, 47.8761251199784],
        [106.790412927315, 47.876098059378],
        [106.790537915992, 47.8760757022319],
        [106.790810825159, 47.8760177346308],
        [106.790927379095, 47.8759978011577],
        [106.791113381377, 47.8759729780705],
        [106.791182816234, 47.8759661782965],
        [106.791246031379, 47.8759620845826],
        [106.791296683895, 47.8759607266063],
        [106.791349721413, 47.875961203247],
        [106.791465735755, 47.8759677089426],
        [106.791569215347, 47.8759780070794],
        [106.791872349829, 47.8760137973989],
        [106.792268389675, 47.8760534781855],
        [106.792583585864, 47.8760894672552],
        [106.792867304882, 47.8761274132495],
        [106.793126756595, 47.8761684250329],
        [106.793366528443, 47.8762107354372],
        [106.793555529064, 47.8762470581553],
        [106.79372475989, 47.8762833619876],
        [106.79387841086, 47.8763206496783],
        [106.794022021799, 47.8763596712619],
        [106.794169453957, 47.8764034079909],
        [106.794321362041, 47.8764520559177],
        [106.794478886392, 47.8765059756703],
        [106.794592025602, 47.8765475549258],
        [106.794716027723, 47.8765963962068],
        [106.795112292398, 47.8767625207737],
        [106.79546940419, 47.8769097343968],
        [106.795575606929, 47.8769562338431],
        [106.795668872021, 47.8769997673255],
        [106.795741480585, 47.8770361655866],
        [106.795815570332, 47.8770757987092],
        [106.795972073053, 47.8771668892406],
        [106.796115677696, 47.8772572818981],
        [106.796442816883, 47.8774707350864],
        [106.796602539176, 47.877569296286],
        [106.797379723396, 47.8780182900121],
        [106.797708804218, 47.8782203200118],
        [106.797788707183, 47.8782672331463],
        [106.79786197495, 47.8783079301669],
        [106.797998956986, 47.8783811718537],
        [106.798093873234, 47.8784296012452],
        [106.798182217236, 47.87847134058],
        [106.798264916193, 47.8785065778164],
        [106.798356243246, 47.8785409463077],
        [106.798458678725, 47.8785752005851],
        [106.798574536586, 47.8786102363734],
        [106.798726986961, 47.8786530593912],
        [106.798827503287, 47.8786795642106],
        [106.798937890571, 47.8787064197655],
        [106.799218444875, 47.8787683326924],
        [106.799353680428, 47.8787941189535],
        [106.799690430669, 47.8788501790925],
        [106.799782548226, 47.878868493786],
        [106.79986428311, 47.878887589091],
        [106.799945053921, 47.8789088616547],
        [106.800011940099, 47.8789244028389],
        [106.800084423657, 47.8789380842252],
        [106.800163179088, 47.878950032618],
        [106.800249587748, 47.8789604611564],
        [106.800418484925, 47.8789753503322],
        [106.800838048337, 47.8790034838238],
        [106.800950266642, 47.8790143728151],
        [106.801046953654, 47.8790270928261],
        [106.801149563602, 47.8790458239057],
        [106.801238353667, 47.8790686334108],
        [106.801278177446, 47.8790817221438],
        [106.801315098213, 47.8790959826935],
        [106.801349225686, 47.879111457328],
        [106.801388889386, 47.8791388893483],
        [106.801431509157, 47.8791621413198],
        [106.801461480863, 47.879185847449],
        [106.801496556221, 47.879219863406],
        [106.801528196169, 47.8792574586648],
        [106.801556470854, 47.8792986952786],
        [106.801581552047, 47.8793438052725],
        [106.801603569249, 47.8793930170741],
        [106.801622684339, 47.8794466976071],
        [106.801647431884, 47.8795419519996],
        [106.80166644625, 47.8796538852187],
        [106.801678900961, 47.8797641403029],
        [106.801702579211, 47.8800328226567],
        [106.801720062931, 47.8801655670873],
        [106.801731704655, 47.8802277273278],
        [106.801745211572, 47.8802848576601],
        [106.801760789629, 47.8803378241313],
        [106.80177857732, 47.8803870746038],
        [106.801814945004, 47.8804891458574],
        [106.801827344856, 47.8805162730076],
        [106.80184100286, 47.8805398163595],
        [106.80186513257, 47.8805733134078],
        [106.801893323618, 47.8806063500031],
        [106.801925063391, 47.8806383289958],
        [106.801959724162, 47.8806686136656],
        [106.801995328322, 47.880695227303],
        [106.802037237628, 47.8807221628975],
        [106.802086217405, 47.8807499564454],
        [106.802146428815, 47.8807809740628],
        [106.802209913757, 47.880809559014],
        [106.802284498131, 47.8808375666005],
        [106.802362975671, 47.8808632071713],
        [106.802528064219, 47.8809133299862],
        [106.802676217633, 47.8809562501309],
        [106.802845159776, 47.8809986450715],
        [106.803006826404, 47.8810350640171],
        [106.803363019088, 47.8811111133872],
        [106.80350723617, 47.8811439017697],
        [106.804328352272, 47.8813367523892],
        [106.804564122137, 47.8813939339829],
        [106.804774571589, 47.8814467952334],
        [106.805132783251, 47.8815385431693],
        [106.805351147637, 47.8815991349921],
        [106.805492462607, 47.8816404534442],
        [106.80557490166, 47.8816676723253],
        [106.805671273011, 47.8817052082288],
        [106.805774892897, 47.8817509936135],
        [106.805949389253, 47.8818404806537],
        [106.806038288137, 47.8818794761569],
        [106.80614937959, 47.881923801942],
        [106.806278441297, 47.8819719156714],
        [106.806383629601, 47.882006583637],
        [106.806425189971, 47.8820177055527],
        [106.806534436015, 47.8820428496978],
        [106.806591184136, 47.8820609629431],
        [106.806659359042, 47.882091859152],
        [106.806722058876, 47.8821280766494],
        [106.806754351732, 47.8821510561264],
        [106.806786463824, 47.8821778712119],
        [106.806819018383, 47.8822090012445],
        [106.806854736757, 47.882247042567],
        [106.806882583365, 47.8822815126817],
        [106.806908997352, 47.8823217753297],
        [106.806991224166, 47.8824754748633],
        [106.807038182266, 47.8825608897733],
        [106.807064151989, 47.8826011470254],
        [106.807089555139, 47.8826330576695],
        [106.807121024216, 47.8826673281347],
        [106.807224128791, 47.8827657976036],
        [106.807338323805, 47.8828708995724],
        [106.807383706293, 47.8829084966298],
        [106.807427334204, 47.8829412994015],
        [106.807524471777, 47.88300569086],
        [106.807572374166, 47.8830338207543],
        [106.807619969886, 47.8830593210309],
        [106.807685123969, 47.8830903998021],
        [106.807756084975, 47.883120161966],
        [106.807832834917, 47.8831486030257],
        [106.807915382789, 47.8831757229812],
        [106.808002119702, 47.883201452585],
        [106.808076295784, 47.8832208032975],
        [106.808144850205, 47.8832355746621],
        [106.808209193999, 47.8832460337775],
        [106.808293816606, 47.8832535440159],
        [106.808458175804, 47.8832594048977],
        [106.808861526239, 47.883276108006],
        [106.809010128415, 47.8832797385691],
        [106.809394914144, 47.8832846425723],
        [106.809507057805, 47.8832881067607],
        [106.80960766766, 47.8832931699439],
        [106.809833431668, 47.8833097876167],
        [106.810063210249, 47.8833321033939],
        [106.81025176121, 47.883356130581],
        [106.810588093266, 47.8834071940868],
        [106.810717752123, 47.8834255420552],
        [106.810982546707, 47.8834593988322],
        [106.811253945014, 47.8834917582381],
        [106.811532526205, 47.8835226877219],
        [106.81181907539, 47.8835522772159],
        [106.812001972313, 47.883569320268],
        [106.812449135919, 47.8836068858491],
        [106.812652880926, 47.8836255800565],
        [106.812989720199, 47.8836573513058],
        [106.813089052118, 47.8836686746697],
        [106.813177550803, 47.883680703102],
        [106.813314879978, 47.8837013236572],
        [106.813404672787, 47.883716425073],
        [106.813485378847, 47.8837324563878],
        [106.813557019741, 47.883749647828],
        [106.813635865103, 47.8837724519372],
        [106.813719044299, 47.8838003731887],
        [106.813808441406, 47.8838339979407],
        [106.81391280773, 47.8838766087186],
        [106.814019306346, 47.8839227223558],
        [106.814095689365, 47.883960187213],
        [106.814159278628, 47.8839960305924],
        [106.814219956786, 47.884034256276],
        [106.814277722939, 47.8840748615656],
        [106.814332576187, 47.8841178500588],
        [106.81592097857, 47.8855108000834],
        [106.81794047907, 47.8872576126487],
        [106.820290680071, 47.8893127847572],
        [106.822269585173, 47.8910332822602],
        [106.824338642814, 47.8928508840611],
        [106.826396933772, 47.894547644858],
        [106.828153860113, 47.896007220257],
        [106.828219378422, 47.8960586992496],
        [106.828287052406, 47.8961086520927],
        [106.828356882964, 47.8961570778869],
        [106.828428870096, 47.8962039766323],
        [106.828543580422, 47.8962726182867],
        [106.828679009329, 47.8963465209752],
        [106.828732000981, 47.8963752687038],
        [106.828762217303, 47.8963891542361],
        [106.82878666897, 47.8963977283725],
        [106.828815331263, 47.8964056118296],
        [106.828916068822, 47.8964269977078],
        [106.829003446052, 47.8964452458515],
        [106.829140952393, 47.8964710366091],
        [106.829289427765, 47.896497199686],
        [106.829455991201, 47.8965236037814],
        [106.829628125937, 47.8965490815749],
        [106.830017162762, 47.8966035993766],
        [106.830332072967, 47.8966494728949],
        [106.830526301348, 47.8966760721431],
        [106.830745011073, 47.8967053441763],
        [106.830870956629, 47.8967181981864],
        [106.830971359641, 47.896724360341],
        [106.831100123672, 47.8967291950963],
        [106.831291938272, 47.8967344363452],
        [106.831357313589, 47.8967339588052],
        [106.831416138244, 47.8967314802737],
        [106.831557296732, 47.8967182377565],
        [106.831634044875, 47.8967145649253],
        [106.83168251024, 47.8967162412616],
        [106.831708976388, 47.8967198601335],
        [106.831737764586, 47.8967257560888],
        [106.831814331067, 47.8967471059942],
        [106.831858253955, 47.8967619358148],
        [106.831946797607, 47.8967962773264],
        [106.832128618041, 47.896863291208],
        [106.832239210371, 47.8969015060997],
        [106.832350428629, 47.8969361201059],
        [106.832475064772, 47.8969713069803],
        [106.832612740186, 47.8970072303994],
        [106.832827672759, 47.8970606186527],
        [106.833001980257, 47.8971047438889],
        [106.833102334705, 47.8971258347895],
        [106.83316746001, 47.8971359215856],
        [106.833240879763, 47.897144548782],
        [106.833474085661, 47.897163856327],
        [106.833599613931, 47.8971745159912],
        [106.833676166022, 47.8971789442529],
        [106.833782811228, 47.8971825028702],
        [106.833850505896, 47.8971798219912],
        [106.83390988903, 47.8971727443267],
        [106.833953427908, 47.8971635253765],
        [106.833980189934, 47.8971545429479],
        [106.834023295339, 47.897136766049],
        [106.834093034166, 47.8971063473801],
        [106.834178716175, 47.8970646817897],
        [106.834224382849, 47.8970474822556],
        [106.834259471697, 47.8970377488931],
        [106.834296953642, 47.8970324518862],
        [106.834362651815, 47.8970287745583],
        [106.834447996578, 47.8970264093414],
        [106.834607765636, 47.8970285200502],
        [106.834732642797, 47.8970300650855],
        [106.834871921702, 47.8970336956486],
        [106.83530466288, 47.8970507503919],
        [106.835446739575, 47.8970551228957],
        [106.835676491177, 47.8970590574296],
        [106.835783253295, 47.8970591527577],
        [106.835845527749, 47.8970567263869],
        [106.835896820582, 47.8970528350204],
        [106.835953156813, 47.8970446781694],
        [106.836099667166, 47.8970158306162],
        [106.836217560192, 47.8969988972813],
        [106.836296300334, 47.8969924275585],
        [106.836334233738, 47.8969920282595],
        [106.836376696128, 47.8969935283287],
        [106.836520967169, 47.8970045899899],
        [106.836735230646, 47.8970180087741],
        [106.836847760116, 47.8970273113614],
        [106.836954247041, 47.8970402687934],
        [106.837048264866, 47.897056922439],
        [106.837125108337, 47.8970738341902],
        [106.837179911224, 47.8970885749778],
        [106.837226148068, 47.8971027743736],
        [106.837261820577, 47.8971155528405],
        [106.837290974799, 47.8971277584394],
        [106.837315617122, 47.8971404199945],
        [106.837349793158, 47.8971628400931],
        [106.83738434691, 47.8971910859999],
        [106.837409917334, 47.8972168308921],
        [106.837440094984, 47.8972532138648],
        [106.837466615992, 47.8972898135741],
        [106.837496638959, 47.8973378355727],
        [106.837514941961, 47.8973738938901],
        [106.837525229306, 47.8973891445934],
        [106.837547070241, 47.8974118380859],
        [106.837570146845, 47.8974289386947],
        [106.837595481646, 47.8974412378229],
        [106.837634657014, 47.8974549147126],
        [106.837677052854, 47.8974658171937],
        [106.837756028618, 47.8974799797173],
        [106.837870390906, 47.89749942306],
        [106.837995483005, 47.8975162817511],
        [106.838134376101, 47.8975310369279],
        [106.838303881219, 47.8975454809392],
        [106.838407894109, 47.8975528194072],
        [106.838504895884, 47.897551266278],
        [106.838576475624, 47.8975467930501],
        [106.838631685904, 47.8975402315965],
        [106.838687266704, 47.8975287598444],
        [106.838777668355, 47.8975041328096],
        [106.838833090875, 47.8974876293507],
        [106.838959853914, 47.8974456723799],
        [106.839022642781, 47.8974281850627],
        [106.839103125809, 47.897409864074],
        [106.839165518974, 47.8973988878484],
        [106.839223791445, 47.8973919333911],
        [106.839278927081, 47.8973880681049],
        [106.839337054761, 47.8973867973629],
        [106.83938604443, 47.8973886023022],
        [106.839419852644, 47.8973926870229],
        [106.83951394871, 47.8974090600801],
        [106.839575636806, 47.8974152069463],
        [106.839631419954, 47.8974184310158],
        [106.839667205777, 47.8974185883972],
        [106.839707041247, 47.8974167250019],
        [106.839841060916, 47.8974040841312],
        [106.839891845632, 47.8974007530423],
        [106.84000338315, 47.8973976431868],
        [106.840115954887, 47.8973971602508],
        [106.840246716313, 47.8973994301396],
        [106.840350498976, 47.8974046543014],
        [106.840456437315, 47.8974146871382],
        [106.840592448982, 47.8974322850719],
        [106.840693216219, 47.8974474818159],
        [106.840807880679, 47.8974670933317],
        [106.840928968097, 47.8974885340687],
        [106.840999977667, 47.8975045249139],
        [106.841077323859, 47.8975261257302],
        [106.841128601404, 47.8975452246324],
        [106.841167107676, 47.897564592432],
        [106.841207130205, 47.8975889802473],
        [106.841230474807, 47.8976061923719],
        [106.841286376665, 47.8976529796014],
        [106.84132219936, 47.8976803693536],
        [106.841344756156, 47.8976948070697],
        [106.84137720999, 47.8977105092327],
        [106.84141611736, 47.8977251717793],
        [106.841457625569, 47.8977368206978],
        [106.841513998672, 47.8977483589996],
        [106.841574302712, 47.8977567973384],
        [106.841681964151, 47.8977659209605],
        [106.841910139242, 47.8977825170496],
        [106.841994869767, 47.8977920219843],
        [106.842071493804, 47.8978024352343],
        [106.842192709826, 47.8978229964342],
        [106.842245130409, 47.8978276261441],
        [106.842303412772, 47.8978302233862],
        [106.842423831095, 47.8978282907431],
        [106.842516878551, 47.8978268887],
        [106.842567584127, 47.8978237320796],
        [106.842621783569, 47.8978170384256],
        [106.842667452941, 47.8978086252679],
        [106.842702504917, 47.8977990393942],
        [106.842779984209, 47.8977730579803],
        [106.842847678877, 47.897752685638],
        [106.842889329179, 47.8977420430609],
        [106.842929526177, 47.8977343169852],
        [106.842992461633, 47.897724632186],
        [106.843078946736, 47.8977130516161],
        [106.8431890957, 47.8977012192359],
        [106.843290636354, 47.897692607328],
        [106.843466166031, 47.8976810150668],
        [106.843653162963, 47.8976690091175],
        [106.843747905641, 47.89766270487],
        [106.843788045082, 47.8976620600561],
        [106.843823286815, 47.8976648704375],
        [106.843842734655, 47.8976690369965],
        [106.843858766869, 47.8976744284322],
        [106.843880144653, 47.8976861699808],
        [106.843889412167, 47.897689127851],
        [106.843911989647, 47.8976887654242],
        [106.8439296937, 47.8976860422771],
        [106.843954337822, 47.8976796453994],
        [106.843986592008, 47.897668999225],
        [106.844002329244, 47.897668253687],
        [106.844024282595, 47.8976700811094],
        [106.844067289974, 47.8976795185949],
        [106.844123199926, 47.8976988774013],
        [106.844166327814, 47.8977116891432],
        [106.844193140201, 47.8977165976429],
        [106.844219309574, 47.8977192776226],
        [106.844247166074, 47.897720038449],
        [106.84426948365, 47.8977184709307],
        [106.844287487178, 47.8977147459388],
        [106.844316730433, 47.8977058957105],
        [106.844376548839, 47.8976848030113],
        [106.844415209794, 47.8976687537101],
        [106.844447892956, 47.8976531468753],
        [106.844475871764, 47.8976377468846],
        [106.844489821148, 47.8976322169533],
        [106.844504972926, 47.8976289290319],
        [106.844529780725, 47.8976265107549],
        [106.844565025156, 47.8976249207536],
        [106.844635204651, 47.897626505359],
        [106.844742231169, 47.8976240780888],
        [106.844795882024, 47.897627298561],
        [106.844848924938, 47.897636575068],
        [106.844917438889, 47.8976574177557],
        [106.845000825828, 47.8976729589399],
        [106.845073939811, 47.8976856303876],
        [106.8451194536, 47.8976913078077],
        [106.845174959757, 47.8976947297281],
        [106.845224999834, 47.8976946748694],
        [106.845297572425, 47.8976884452656],
        [106.845392423022, 47.8976734157956],
        [106.845480106921, 47.8976686314023],
        [106.845585532646, 47.8976686233084],
        [106.845640147575, 47.8976715443064],
        [106.84570129338, 47.8976768907759],
        [106.845824879115, 47.8976934706772],
        [106.845969414557, 47.8977154438127],
        [106.846074859167, 47.8977350292483],
        [106.846145704161, 47.897750770082],
        [106.84618018237, 47.8977543278],
        [106.846226222262, 47.8977562271682],
        [106.846306500245, 47.8977549357418],
        [106.846439401157, 47.8977511100257],
        [106.846542438283, 47.8977545166577],
        [106.84660952501, 47.897759030355],
        [106.846658259271, 47.8977644703541],
        [106.846708658178, 47.8977722072216],
        [106.84674164621, 47.8977800088404],
        [106.846773359003, 47.89779066131],
        [106.846795108208, 47.8978010934458],
        [106.846820916052, 47.8978209342887],
        [106.846841884645, 47.8978459165559],
        [106.846852580282, 47.8978643130876],
        [106.84686109956, 47.897871055305],
        [106.846878267618, 47.8978807805736],
        [106.846926774351, 47.8979036332461],
        [106.846988669292, 47.8979302351922],
        [106.84706177608, 47.8979588543177],
        [106.847145976905, 47.897988235169],
        [106.847297967727, 47.8980360791018],
        [106.847428827179, 47.8980783859088],
        [106.84750357523, 47.8981002906959],
        [106.847640306355, 47.8981335386319],
        [106.847776859415, 47.8981617251835],
        [106.847898057449, 47.8981817198106],
        [106.84800671264, 47.8982019140871],
        [106.848118237567, 47.8982321915624],
        [106.848161367253, 47.8982450006063],
        [106.848211781449, 47.8982509424271],
        [106.848272170025, 47.8982550343424],
        [106.848340085926, 47.8982590048492],
        [106.848375871749, 47.8982663666995],
        [106.848413561437, 47.8982780776712],
        [106.848464576379, 47.8983008889749],
        [106.848549568608, 47.8983479837725],
        [106.848604288757, 47.8983808629865],
        [106.848640258042, 47.8983974725654],
        [106.848668805221, 47.8984068318099],
        [106.848695879311, 47.8984116368876],
        [106.84873267957, 47.8984148069978],
        [106.848816304829, 47.8984134598133],
        [106.848853455822, 47.8984156595551],
        [106.848880100037, 47.8984191839982],
        [106.848911177909, 47.898426773377],
        [106.848944376382, 47.8984384061076],
        [106.84896857444, 47.898449929121],
        [106.849012635825, 47.8984755687925],
        [106.849063853114, 47.8985040026576],
        [106.849108380348, 47.8985325444414],
        [106.849130989304, 47.8985448138921],
        [106.849145814628, 47.8985499472224],
        [106.849162209269, 47.8985518942546],
        [106.849182690429, 47.8985516028742],
        [106.849206835427, 47.8985483194494],
        [106.849229198868, 47.8985418524246],
        [106.849244563786, 47.8985347109082],
        [106.849258744296, 47.898525620561],
        [106.849269514577, 47.8985154330408],
        [106.849284461309, 47.8984959474301],
        [106.849297628283, 47.8984768880979],
        [106.849331911339, 47.8984186587941],
        [106.849345170044, 47.8983988692125],
        [106.849354284673, 47.8983890387232],
        [106.849370592979, 47.8983777153594],
        [106.849390357379, 47.8983682023307],
        [106.849411047182, 47.8983623441469],
        [106.849450165893, 47.8983559841414],
        [106.849525434651, 47.8983456779107],
        [106.849606898839, 47.898339953726],
        [106.849673407302, 47.8983392288724],
        [106.84975089199, 47.8983421363806],
        [106.84982280358, 47.8983478407803],
        [106.849905402712, 47.8983576523838],
        [106.849976028271, 47.898368552167],
        [106.850051050616, 47.8983829413198],
        [106.85013209482, 47.8984011049271],
        [106.850225741225, 47.898424511582],
        [106.850347903333, 47.8984588998584],
        [106.850472729233, 47.8984993045993],
        [106.850585997946, 47.8985396301998],
        [106.850666120345, 47.8985727117613],
        [106.85072042141, 47.8985977416925],
        [106.850765133005, 47.8986206312372],
        [106.850801846028, 47.8986415737497],
        [106.850833312407, 47.8986622959283],
        [106.850870422932, 47.8986886172859],
        [106.850888434554, 47.8987064220637],
        [106.850899727341, 47.8987250182451],
        [106.850906524417, 47.8987443914406],
        [106.850906928212, 47.8987632700089],
        [106.85089857441, 47.8988030389291],
        [106.85089027007, 47.8988594273208],
        [106.850885181706, 47.8989221262552],
        [106.850883817434, 47.8989625912507],
        [106.85088548118, 47.8989990605582],
        [106.850889333876, 47.8990368797483],
        [106.850894416844, 47.8990619366591],
        [106.850904885852, 47.8990907743199],
        [106.850923583657, 47.8991289883122],
        [106.850956247933, 47.8991804619088],
        [106.851032654334, 47.8992780266597],
        [106.851148167754, 47.8994223120901],
        [106.851201397726, 47.89949216693],
        [106.851240229553, 47.8995464140358],
        [106.851271586215, 47.8995960260358],
        [106.851296905728, 47.8996388868252],
        [106.851310948641, 47.8996674142198],
        [106.851325836019, 47.8997100079106],
        [106.851341639805, 47.8997772043546],
        [106.851354828363, 47.899849618665],
        [106.851368289415, 47.8999613324496],
        [106.851382932177, 47.9001216473962],
        [106.851385900839, 47.9002048751549],
        [106.851390447811, 47.9002385619601],
        [106.851397058727, 47.9002544089139],
        [106.851404711958, 47.9002630900696],
        [106.851464437734, 47.9003244292291],
        [106.851570573923, 47.9004426550045],
        [106.851657069818, 47.9005474089358],
        [106.85171034026, 47.9006702824076],
        [106.851758265132, 47.9007637462499],
        [106.851802046827, 47.9008601328889],
        [106.851834030316, 47.9009531398756],
        [106.851804993905, 47.9010231368084],
        [106.851793666045, 47.901033311738],
        [106.851780342589, 47.9010518899328],
        [106.851771613769, 47.9010719304253],
        [106.851769227868, 47.9010872350879],
        [106.851769794441, 47.9011147228662],
        [106.851771077773, 47.9011507128352],
        [106.851776174231, 47.9011696138866],
        [106.851785983137, 47.9011932372781],
        [106.851800601617, 47.9012186206429],
        [106.851835462936, 47.9012667118893],
        [106.851909583261, 47.9013697238337],
        [106.851951872081, 47.9014336377522],
        [106.851993320935, 47.9015042875928],
        [106.852077138649, 47.9016611887129],
        [106.852157625274, 47.9018080686875],
        [106.852205673353, 47.9018864374092],
        [106.852262085127, 47.901966551715],
        [106.852295038985, 47.9020159892465],
        [106.852314913103, 47.9020399732662],
        [106.852341000637, 47.9020628619116],
        [106.852394100208, 47.9021017162213],
        [106.852504036032, 47.902180967178],
        [106.852619481104, 47.9022603800126],
        [106.85269936968, 47.9023083561458],
        [106.852767742437, 47.9023426383022],
        [106.852866176833, 47.9023866888946],
        [106.852974144042, 47.9024310542498],
        [106.853137729822, 47.9024925912601],
        [106.853246555884, 47.9025335625739],
        [106.853310664955, 47.9025550689613],
        [106.85338012859, 47.9025755941884],
        [106.853428952784, 47.9025869202502],
        [106.853478288692, 47.902594166088],
        [106.853549943075, 47.9026007212464],
        [106.853614570156, 47.9026047367193],
        [106.853697456173, 47.9026073429546],
        [106.853784512345, 47.902608187418],
        [106.853895065105, 47.9026109033705],
        [106.853973602, 47.9026086199919],
        [106.854005457786, 47.9026091200149],
        [106.85404422576, 47.9026110535573],
        [106.854065912912, 47.9026148963604],
        [106.854086521776, 47.9026225891612],
        [106.854103354386, 47.9026322973427],
        [106.8541172642, 47.9026458267435],
        [106.854127895086, 47.9026634102882],
        [106.854132992444, 47.9026819093427],
        [106.854132605735, 47.9027015964016],
        [106.854126708881, 47.9027191286849],
        [106.854113900736, 47.9027401611296],
        [106.854078390106, 47.9027767464497],
        [106.854063133107, 47.9027958183724],
        [106.854056097711, 47.9028086148257],
        [106.854053289128, 47.9028233052514],
        [106.854054118303, 47.9028469097572],
        [106.854058668873, 47.902880595663],
        [106.854067779005, 47.9028983347904],
        [106.854083452389, 47.9029184589198],
        [106.854102003605, 47.9029365406889],
        [106.854124880559, 47.9029538013769],
        [106.854160646597, 47.9029734227853],
        [106.854209958223, 47.902992938973],
        [106.854255604213, 47.903006063679],
        [106.854324741394, 47.903020344913],
        [106.854375148394, 47.903029160967],
        [106.854427891834, 47.9030364068048],
        [106.85453988261, 47.9030461293754],
        [106.854607473856, 47.9030493552436],
        [106.854653781747, 47.9030487895701],
        [106.85468690018, 47.9030461230802],
        [106.854727136748, 47.9030408521537],
        [106.854793640714, 47.9030285251464],
        [106.854825999221, 47.903019501349],
        [106.854869777318, 47.9030047866416],
        [106.85490750208, 47.9029909667598],
        [106.854926002933, 47.9029858729997],
        [106.854948745888, 47.9029824510793],
        [106.854976022326, 47.9029805634023],
        [106.855011417843, 47.9029818296478],
        [106.855076780569, 47.9029901888462],
        [106.855158919249, 47.9030007576789],
        [106.855315661189, 47.9030245897131],
        [106.855407517043, 47.9030371172692],
        [106.855453620788, 47.9030448667273],
        [106.855543683394, 47.9030660349696],
        [106.855649655907, 47.9030979662982],
        [106.855716650903, 47.9031216049781],
        [106.855815907278, 47.9031605501194],
        [106.855982398769, 47.9032298797552],
        [106.85610133321, 47.9032797237803],
        [106.85616424978, 47.9033060010711],
        [106.856199794585, 47.9033186446398],
        [106.856255778282, 47.9033345860224],
        [106.856297692085, 47.9033418201689],
        [106.856327232116, 47.9033435342768],
        [106.856357988031, 47.9033430954076],
        [106.856386733961, 47.903340058397],
        [106.85644121579, 47.9033304959057],
        [106.856570990659, 47.903308779077],
        [106.856707310794, 47.9032834289871],
        [106.856873447052, 47.9032492322663],
        [106.85697252806, 47.9032309409552],
        [106.857036480649, 47.9032218371182],
        [106.857088128714, 47.9032173261187],
        [106.85716670428, 47.9032129769973],
        [106.857223141235, 47.9032093257498],
        [106.857253600373, 47.9032093212532],
        [106.857288029119, 47.9032131199896],
        [106.857344486759, 47.9032236051853],
        [106.857428954683, 47.9032408523835],
        [106.857499735824, 47.9032593550352],
        [106.857535617875, 47.9032712656564],
        [106.857625202041, 47.9033045900348],
        [106.85770820407, 47.9033327343183],
        [106.857760622855, 47.9033474130527],
        [106.857806865095, 47.903356313643],
        [106.857915471722, 47.9033719150819],
        [106.858013064351, 47.9033885858146],
        [106.858070483366, 47.9034009164192],
        [106.858141313971, 47.9034202896147],
        [106.858195706767, 47.9034394020068],
        [106.858250140931, 47.90346400476],
        [106.858294571937, 47.9034895688886],
        [106.858323686589, 47.9035113954346],
        [106.858363572421, 47.9035469699168],
        [106.858412228442, 47.9035921986211],
        [106.858439986916, 47.9036245067657],
        [106.858454343693, 47.9036474619609],
        [106.85847218984, 47.9036825040443],
        [106.858497700908, 47.9037406101411],
        [106.858509594442, 47.9037640743526],
        [106.858519059807, 47.9037762763541],
        [106.858533016386, 47.9037869827831],
        [106.858556744998, 47.903800423151],
        [106.858580654374, 47.903811132278],
        [106.858610004648, 47.9038203017656],
        [106.858643556555, 47.9038285854209],
        [106.858725702429, 47.9038449530822],
        [106.858840800363, 47.9038737952395],
        [106.858918156448, 47.9038913518045],
        [106.858993979189, 47.9039059082311],
        [106.859127015899, 47.9039284821138],
        [106.85931491665, 47.9039602245847],
        [106.859453605599, 47.9039817111871],
        [106.859604724978, 47.9040039613138],
        [106.859695758852, 47.904013799897],
        [106.859752420638, 47.9040183702517],
        [106.85978632328, 47.9040190852127],
        [106.859866369238, 47.9040110362803],
        [106.859915715938, 47.9040087430091],
        [106.859950001691, 47.904009681002],
        [106.859994208766, 47.9040167766529],
        [106.86006136474, 47.9040348854017],
        [106.8601152746, 47.904051085789],
        [106.86016635879, 47.904069195437],
        [106.860229589224, 47.9040960752737],
        [106.86029231334, 47.9041279229653],
        [106.860355145374, 47.9041645838285],
        [106.860398516978, 47.9041959737652],
        [106.860425563189, 47.9042220487086],
        [106.860468165873, 47.9042713702276],
        [106.86049312206, 47.9043021369341],
        [106.860506576817, 47.9043157607638],
        [106.860528663267, 47.9043329054393],
        [106.860551194882, 47.9043465481547],
        [106.860580423748, 47.904358481259],
        [106.860635876844, 47.9043744352321],
        [106.860711306582, 47.9043941465726],
        [106.860835026315, 47.9044207224384],
        [106.860923248909, 47.9044395011821],
        [106.860980005123, 47.9044498820564],
        [106.861070100105, 47.9044618484356],
        [106.861178266064, 47.9044714253161],
        [106.861253543816, 47.9044751071405],
        [106.861422878963, 47.904478713422],
        [106.861548930639, 47.9044825670169],
        [106.861617312389, 47.9044868136156],
        [106.86167979009, 47.904493846314],
        [106.861798928678, 47.9045108767756],
        [106.862074781326, 47.904549166311],
        [106.862189086957, 47.9045630662326],
        [106.862276307705, 47.9045684037089],
        [106.862321228842, 47.9045677274187],
        [106.862369896554, 47.9045646346502],
        [106.862436560599, 47.9045568015552],
        [106.862473201677, 47.9045582071956],
        [106.862520517708, 47.9045644421953],
        [106.862545369573, 47.9045696573638],
        [106.862602299357, 47.9045860178305],
        [106.862628618916, 47.9045919470607],
        [106.86267054441, 47.9045980516588],
        [106.862712655165, 47.9046018369053],
        [106.862753076993, 47.9046035114429],
        [106.862786334822, 47.90460289181],
        [106.862821084625, 47.9045994896748],
        [106.862862954362, 47.904592645834],
        [106.862903967944, 47.904583905323],
        [106.862942916682, 47.9045733337924],
        [106.862979073925, 47.9045611326902],
        [106.863011961233, 47.9045474638944],
        [106.863031892008, 47.9045362907173],
        [106.863075622442, 47.9045060600067],
        [106.863100428442, 47.9044942618008],
        [106.86312749174, 47.9044866760194],
        [106.863163504192, 47.9044797341525],
        [106.863209157377, 47.9044750918521],
        [106.863293810561, 47.9044731178402],
        [106.863402261605, 47.9044696248733],
        [106.863474459179, 47.904470185151],
        [106.863554920623, 47.9044744596287],
        [106.863615447695, 47.9044814005962],
        [106.863678884973, 47.9044925018276],
        [106.863720042446, 47.9045044601128],
        [106.863745090364, 47.9045167502479],
        [106.863798680964, 47.9045504487443],
        [106.863851944212, 47.9045786595775],
        [106.863890701395, 47.9045962197398],
        [106.863937094721, 47.904612375161],
        [106.864009161893, 47.9046325586457],
        [106.864104716659, 47.9046557269803],
        [106.864221696874, 47.9046786228202],
        [106.864314059047, 47.904693994932],
        [106.864396704944, 47.9047050404054],
        [106.864512933325, 47.904715346636],
        [106.864644987077, 47.9047212641751],
        [106.864748541312, 47.9047222947981],
        [106.864862515992, 47.9047199808425],
        [106.865036230837, 47.90471040666],
        [106.865209138091, 47.9047030699907],
        [106.865317160159, 47.9047035906982],
        [106.865372046683, 47.9047070126186],
        [106.86548164796, 47.904716673136],
        [106.865669634146, 47.904731624365],
        [106.865746203325, 47.9047407731682],
        [106.865816596859, 47.9047509642857],
        [106.865881619641, 47.9047621122817],
        [106.865942304993, 47.9047744572754],
        [106.865999753686, 47.904788251077],
        [106.866060880605, 47.9048050666006],
        [106.866206154391, 47.9048511928283],
        [106.866305699449, 47.9048866530966],
        [106.866413133359, 47.9049288537836],
        [106.866562757166, 47.904993943116],
        [106.866694452087, 47.9050533235521],
        [106.866763369834, 47.9050807088077],
        [106.866836590836, 47.9051046388681],
        [106.866925808979, 47.9051298342745],
        [106.867020835843, 47.9051512579243],
        [106.86705749131, 47.905161452639],
        [106.867105837065, 47.9051789822243],
        [106.867149191582, 47.9051982241188],
        [106.867183897319, 47.9052161619963],
        [106.867207276994, 47.9052310385816],
        [106.86722966112, 47.9052504846222],
        [106.867255893445, 47.9052797638501],
        [106.867291127084, 47.9053287067545],
        [106.867334265764, 47.9054112816054],
        [106.867357753358, 47.9054429404394],
        [106.867379779553, 47.9054668093459],
        [106.867398941408, 47.9054829962433],
        [106.867422767147, 47.905499541071],
        [106.867496275033, 47.9055414377872],
        [106.86755434156, 47.9055714814387],
        [106.867605270167, 47.9055936821028],
        [106.86766798439, 47.9056150643838],
        [106.86774062533, 47.9056342433257],
        [106.867786872966, 47.9056433912296],
        [106.867885447655, 47.9056588946423],
        [106.86801346435, 47.9056815701484],
        [106.868148413918, 47.9057108835505],
        [106.868307268366, 47.9057533126653],
        [106.868362487639, 47.9057690013384],
        [106.868391712907, 47.9057744449348],
        [106.868413493588, 47.9057759432052],
        [106.868452010652, 47.9057757147775],
        [106.868508882879, 47.9057747893751],
        [106.868588766958, 47.9057622348393],
        [106.868637928398, 47.9057604236047],
        [106.86868586586, 47.9057629048343],
        [106.868720883662, 47.9057681047143],
        [106.868773494901, 47.9057794838362],
        [106.868840402662, 47.9057955960899],
        [106.868891798917, 47.9058113189373],
        [106.868969958097, 47.9058438078455],
        [106.869010773828, 47.9058550376799],
        [106.869050977121, 47.9058627448698],
        [106.86908879721, 47.9058661892733],
        [106.869158273436, 47.905867749597],
        [106.869274337241, 47.905870486234],
        [106.869375081095, 47.9058703468391],
        [106.869467359631, 47.9058673224191],
        [106.869553031747, 47.9058613221424],
        [106.869649725954, 47.9058507443165],
        [106.869772694754, 47.9058262341934],
        [106.869833354026, 47.9058174927831],
        [106.869879342658, 47.9058132443858],
        [106.869942084759, 47.9058108890613],
        [106.869986477094, 47.9058137489054],
        [106.870020109041, 47.9058199065635],
        [106.87005060685, 47.9058284591162],
        [106.870075066611, 47.9058391295722],
        [106.870125665167, 47.905867749597],
        [106.870166240779, 47.9058884537891],
        [106.870190363295, 47.9058982060374],
        [106.870219328659, 47.905905912328],
        [106.870257839428, 47.9059128613895],
        [106.87029975503, 47.9059174056638],
        [106.870361871203, 47.9059201692804],
        [106.87043040404, 47.9059201953608],
        [106.870555822593, 47.9059147580597],
        [106.870697373185, 47.9059094340732],
        [106.870793105118, 47.905904138865],
        [106.870906315374, 47.9058958731961],
        [106.870983307234, 47.9058875346821],
        [106.871116394306, 47.9058651091875],
        [106.87127788017, 47.9058340412081],
        [106.871498519841, 47.9057868573776],
        [106.871657144062, 47.9057506497727],
        [106.871999700326, 47.9056684013757],
        [106.872353874931, 47.9055885901413],
        [106.872520869143, 47.9055473652188],
        [106.872639334138, 47.905516192918],
        [106.872733484163, 47.9054896764075],
        [106.8728085164, 47.9054670206865],
        [106.872875335129, 47.905444802036],
        [106.872937070889, 47.9054218189618],
        [106.87307998935, 47.9053649377417],
        [106.873327724695, 47.9052731178601],
        [106.87376354785, 47.9051062045878],
        [106.874016091869, 47.9050072737667],
        [106.874195860051, 47.9049348450671],
        [106.874423803116, 47.904842828234],
        [106.874554085203, 47.9047877879261],
        [106.874667130883, 47.9047373053824],
        [106.874766071597, 47.90468920874],
        [106.87485477173, 47.9046427470652],
        [106.874942981733, 47.904582788365],
        [106.874982009612, 47.9045611218983],
        [106.875031680967, 47.9045363239922],
        [106.875098809962, 47.9045055276081],
        [106.875156934045, 47.9044825121583],
        [106.875256237186, 47.9044516303385],
        [106.875325838417, 47.9044324882687],
        [106.875366723396, 47.9044245634429],
        [106.87540237432, 47.9044199840951],
        [106.875482661296, 47.9044186719842],
        [106.875592974836, 47.9044146187397],
        [106.875669672617, 47.9044066138742],
        [106.875715929247, 47.9043974758629],
        [106.875802428739, 47.9043751852666],
        [106.876036488094, 47.9043180486391],
        [106.876183804239, 47.9042766726304],
        [106.876344017562, 47.9042207213093],
        [106.876398727819, 47.9042033877762],
        [106.876488238242, 47.9041794181457],
        [106.876640901756, 47.9041431619774],
        [106.876827015554, 47.904106358122],
        [106.877036631335, 47.9040714212591],
        [106.877233108022, 47.9040434496455],
        [106.877312987604, 47.9040308897138],
        [106.877347373183, 47.9040270891789],
        [106.87736292336, 47.9040233210195],
        [106.877377879985, 47.9040157244462],
        [106.877395644294, 47.9040025295931],
        [106.877424612356, 47.9039705470032],
        [106.877460107698, 47.9039339553878],
        [106.877486686262, 47.9039130389556],
        [106.877512331329, 47.9038970876805],
        [106.87753835681, 47.9038853641183],
        [106.877584949786, 47.9038688921357],
        [106.877639083577, 47.9038507294277],
        [106.877693845994, 47.9038346270664],
        [106.877748833242, 47.9038207046618],
        [106.877803702679, 47.9038090467501],
        [106.877871384757, 47.9037976937087],
        [106.877943553552, 47.9037887526489],
        [106.878020274716, 47.9037824627905],
        [106.878097191033, 47.9037794869338],
        [106.878163144613, 47.9037804429132],
        [106.878298313616, 47.9037874504306],
        [106.878469247758, 47.9037936557527],
        [106.878553397321, 47.9037944966188],
        [106.878616520736, 47.9037934965727],
        [106.878756778103, 47.9037844493929],
        [106.87905720023, 47.9037615256739],
        [106.87921485678, 47.9037467929801],
        [106.879354032263, 47.9037319092003],
        [106.87945446765, 47.9037190030296],
        [106.879674710719, 47.9036871769217],
        [106.879767051308, 47.9036756314253],
        [106.879937803787, 47.903657227699],
        [106.880053928746, 47.9036484260341],
        [106.880122787137, 47.903644686653],
        [106.880164241387, 47.9036443691924],
        [106.8802095906, 47.9036469043812],
        [106.880254887653, 47.9036518866253],
        [106.880332399321, 47.9036663720055],
        [106.880447196881, 47.9036937509659],
        [106.880521200293, 47.9037037918965],
        [106.880596101229, 47.903709543061],
        [106.880680391987, 47.9037104306919],
        [106.880760425353, 47.903707683263],
        [106.880941624357, 47.9036977151775],
        [106.881022987821, 47.9036955702944],
        [106.881190901139, 47.9036946116171],
        [106.88129411633, 47.9036956296496],
        [106.881431516551, 47.9037001298572],
        [106.88155227212, 47.903707152663],
        [106.881662418386, 47.9037119703312],
        [106.881729815379, 47.9037109945668],
        [106.881783009378, 47.9037066697271],
        [106.881829846071, 47.9037003519897],
        [106.881873180803, 47.9036915179492],
        [106.881932733009, 47.9036761593273],
        [106.882002661594, 47.9036560028223],
        [106.882061810904, 47.9036357797674],
        [106.882123683361, 47.9036102767929],
        [106.88218697315, 47.9035797106352],
        [106.882236091423, 47.9035530673203],
        [106.882275499715, 47.9035287442562],
        [106.882318788581, 47.9034972931656],
        [106.882360109731, 47.9034620856068],
        [106.882414938699, 47.9034049193016],
        [106.882440723161, 47.9033774872813],
        [106.882470013181, 47.9033544997105],
        [106.882491677849, 47.9033412482001],
        [106.882515948752, 47.903328988642],
        [106.882554330018, 47.903315199337],
        [106.882631891149, 47.9032955770293],
        [106.882750524317, 47.9032648786713],
        [106.88291721186, 47.9032256268612],
        [106.883157078137, 47.9031726334103],
        [106.883372323674, 47.9031303832606],
        [106.883564768699, 47.903095985991],
        [106.883704301213, 47.9030734759602],
        [106.883831363727, 47.9030563249894],
        [106.883948270197, 47.903044408073],
        [106.884025046219, 47.9030386461167],
        [106.8840639392, 47.9030389078194],
        [106.884115529708, 47.9030416624428],
        [106.884253336422, 47.9030574068739],
        [106.884451729564, 47.9030751442026],
        [106.884534927645, 47.9030801893993],
        [106.88461241683, 47.9030830222637],
        [106.88474992317, 47.9030837219363],
        [106.884841090144, 47.9030883453509],
        [106.884911037614, 47.9030933150045],
        [106.885108680721, 47.9031063866505],
        [106.885282880301, 47.9031206130259],
        [106.885394832406, 47.9031343222912],
        [106.885520014437, 47.9031567432891],
        [106.885596467603, 47.9031738438978],
        [106.885648300928, 47.9031811508895],
        [106.885688166975, 47.9031830250766],
        [106.885730227368, 47.9031818460654],
        [106.885766542892, 47.9031790123016],
        [106.885790635729, 47.9031747342266],
        [106.885817130656, 47.9031661735801],
        [106.885838475166, 47.9031555912576],
        [106.885848728336, 47.9031474532924],
        [106.885870709566, 47.9031244657216],
        [106.885893889591, 47.903106689722],
        [106.885923945833, 47.903086876758],
        [106.885959747844, 47.9030656221807],
        [106.885989379606, 47.9030511278074],
        [106.886023071807, 47.9030385301041],
        [106.886061321773, 47.9030275089125],
        [106.886133635359, 47.9030140829336],
        [106.886189778236, 47.9030053379261],
        [106.886233231678, 47.9030002090925],
        [106.886281234791, 47.9029967700849],
        [106.886354345177, 47.9029941386686],
        [106.886469542935, 47.9029922455957],
        [106.886518592859, 47.9029883524306],
        [106.886569287643, 47.9029824483814],
        [106.886662746089, 47.9029666338032],
        [106.886713777219, 47.9029556791613],
        [106.886867260016, 47.9029183995645],
        [106.886959987314, 47.9029004194189],
        [106.887041393945, 47.9028868432533],
        [106.887134926136, 47.9028730674382],
        [106.887216704188, 47.9028696832893],
        [106.887307649029, 47.9028681877168],
        [106.887365397195, 47.9028713182568],
        [106.887391455052, 47.9028759659531],
        [106.88741737801, 47.9028827018752],
        [106.887446562809, 47.9028925539483],
        [106.887466623086, 47.9029022882101],
        [106.887491617045, 47.9029222747432],
        [106.887516757592, 47.9029463370039],
        [106.887550774449, 47.9029641345872],
        [106.887581607705, 47.9029779059057],
        [106.887602383843, 47.9029823251742],
        [106.887633441031, 47.902985211998],
        [106.887662058357, 47.9029858801942],
        [106.887703164569, 47.9029840662617],
        [106.887739052915, 47.9029818557281],
        [106.88776061596, 47.9029790408501],
        [106.887787568641, 47.9029726637574],
        [106.8878206538, 47.9029617369946],
        [106.887862958809, 47.9029429591503],
        [106.887921871597, 47.9029090798901],
        [106.887971192217, 47.9028792610691],
        [106.88800186989, 47.902856772622],
        [106.888034104291, 47.902825647086],
        [106.888051479192, 47.9028029248152],
        [106.888065255907, 47.9027907102231],
        [106.888080977855, 47.9027800028949],
        [106.888099267367, 47.9027709152456],
        [106.888125782979, 47.9027609093885],
        [106.888161450091, 47.9027512974345],
        [106.888231143952, 47.9027387797709],
        [106.888359204714, 47.9027152013455],
        [106.888472332232, 47.9026980980389],
        [106.888522662791, 47.9026910167771],
        [106.888550853839, 47.9026886470635],
        [106.888581880449, 47.902688737895],
        [106.888626789894, 47.90269147723],
        [106.888696812008, 47.902698483848],
        [106.888775705035, 47.9026992248894],
        [106.888834491019, 47.90270113415],
        [106.888863693804, 47.9026998166433],
        [106.88888760318, 47.9026962742137],
        [106.888920922163, 47.9026886767411],
        [106.888955523579, 47.9026792644366],
        [106.889019923131, 47.9026584927952],
        [106.889175855681, 47.9026090138949],
        [106.889259774119, 47.902581116925],
        [106.889302231113, 47.9025708070971],
        [106.889362102579, 47.9025590349715],
        [106.889426845672, 47.90254810641],
        [106.889497853443, 47.902538444094],
        [106.889642358308, 47.9025252501402],
        [106.889837587635, 47.9025092350132],
        [106.889943257076, 47.9024983532165],
        [106.890035601262, 47.9024950032419],
        [106.890120059293, 47.9024990987544],
        [106.890163391328, 47.9025036601159],
        [106.890193844171, 47.9025088563986],
        [106.890224336584, 47.9025177632842],
        [106.890287521152, 47.9025420593686],
        [106.890350834324, 47.9025629623109],
        [106.890463469913, 47.902594023995],
        [106.890559732446, 47.9026235280534],
        [106.890622777619, 47.9026371186082],
        [106.890662043818, 47.9026420909598],
        [106.890704650999, 47.902644914831],
        [106.890744933432, 47.9026448761601],
        [106.890813304391, 47.9026412968584],
        [106.890951656094, 47.9026317028908],
        [106.891227256033, 47.9026195431575],
        [106.891705001984, 47.9025946022591],
        [106.892272732301, 47.9025674616191],
        [106.892562733084, 47.9025487656131],
        [106.892869806596, 47.9025190223351],
        [106.892989208685, 47.9025100363092],
        [106.89315886399, 47.9025048409257],
        [106.893220965775, 47.9025013371671],
        [106.893284576622, 47.9024950922748],
        [106.893397919079, 47.9024813497346],
        [106.89370833717, 47.9024420934279],
        [106.893803570878, 47.9024302871281],
        [106.893852672963, 47.90242264379],
        [106.893918346854, 47.9024090316515],
        [106.893989317753, 47.9023911297469],
        [106.894039808391, 47.9023758727484],
        [106.894154152692, 47.9023372045984],
        [106.894288397192, 47.9022962018083],
        [106.894459077724, 47.902246831726],
        [106.894616200977, 47.902202101246],
        [106.894713977068, 47.902176789827],
        [106.894911871985, 47.9021345099997],
        [106.895059386881, 47.9021028151928],
        [106.895149451286, 47.9020866984424],
        [106.895192681697, 47.9020816829234],
        [106.895221752282, 47.9020806280186],
        [106.895252792383, 47.9020826002319],
        [106.89528000317, 47.9020869808296],
        [106.895302070734, 47.9020938507506],
        [106.895346213057, 47.9021127104333],
        [106.895395441047, 47.9021320341661],
        [106.895423382983, 47.9021406946374],
        [106.895450627944, 47.9021469116507],
        [106.895470850999, 47.9021496653748],
        [106.895491399609, 47.902150260726],
        [106.895510714348, 47.902149007071],
        [106.895529250275, 47.9021459080073],
        [106.89554668723, 47.902141098433],
        [106.895563633155, 47.902134220418],
        [106.895607226892, 47.9021108380448],
        [106.895660962284, 47.9020928821808],
        [106.89569873291, 47.9020829392763],
        [106.89572928288, 47.9020771242599],
        [106.895773423405, 47.9020739199755],
        [106.89584162619, 47.9020752689585],
        [106.895902684761, 47.9020786036447],
        [106.895968909937, 47.9020853575533],
        [106.896026727352, 47.9020935126056],
        [106.896078340343, 47.9021030571104],
        [106.896146340781, 47.9021204446029],
        [106.896243287698, 47.902151536864],
        [106.896292474318, 47.9021690556574],
        [106.896402644866, 47.9022126260119],
        [106.896452880996, 47.9022309775776],
        [106.896535501712, 47.9022570812993],
        [106.896709496246, 47.9023072032149],
        [106.896863482664, 47.9023534247708],
        [106.896987946137, 47.9023855053868],
        [106.897070755711, 47.9024098068671],
        [106.897127348249, 47.9024295289996],
        [106.897188432001, 47.9024560176311],
        [106.897256504384, 47.9024907908174],
        [106.897295061918, 47.9025136992479],
        [106.89740502742, 47.9025858689428],
        [106.89744243562, 47.9026089941099],
        [106.897464255871, 47.9026190269466],
        [106.897492231082, 47.9026261136043],
        [106.897537270928, 47.9026324502274],
        [106.897570264356, 47.9026350762478],
        [106.897668001777, 47.9026376033428],
        [106.897740837869, 47.9026461531975],
        [106.897817654361, 47.9026643896499],
        [106.897850468824, 47.9026687360733],
        [106.897879530416, 47.902670681307],
        [106.897916307292, 47.9026703395646],
        [106.897948296177, 47.9026671056025],
        [106.897966279021, 47.902662789756],
        [106.89800985567, 47.9026466541198],
        [106.898030756814, 47.9026413598109],
        [106.898064353687, 47.9026379657695],
        [106.898103146843, 47.9026377238519],
        [106.898139921021, 47.9026404883679],
        [106.898175982935, 47.9026462728073],
        [106.898211617672, 47.9026566159101],
        [106.898278880666, 47.9026835847797],
        [106.898372033343, 47.9027193409249],
        [106.898418552574, 47.9027349189814],
        [106.898462276713, 47.9027484762613],
        [106.898488123228, 47.9027532741443],
        [106.898514398721, 47.9027542723918],
        [106.898538859381, 47.9027524350769],
        [106.898560572612, 47.9027473296256],
        [106.898596218141, 47.902734418059],
        [106.898630931073, 47.9027206440425],
        [106.898706868927, 47.9026862602627],
        [106.898750645226, 47.9026660776774],
        [106.89877474256, 47.9026583156288],
        [106.898797564656, 47.9026544899128],
        [106.898821677279, 47.9026526633897],
        [106.89885385682, 47.9026547839911],
        [106.898912811877, 47.9026657853977],
        [106.898973461256, 47.9026771060637],
        [106.89904006145, 47.9026923171967],
        [106.899275064193, 47.9027548866288],
        [106.899422534123, 47.9027906940353],
        [106.899498356864, 47.9028121509601],
        [106.899576611372, 47.9028402970421],
        [106.899741197199, 47.9029081032264],
        [106.899836802327, 47.9029466508673],
        [106.899888296608, 47.9029641876472],
        [106.899937902312, 47.9029763950447],
        [106.900049092692, 47.9029981019809],
        [106.900178390021, 47.9030233306622],
        [106.900250443703, 47.9030396101899],
        [106.900307379782, 47.9030546702369],
        [106.900356364055, 47.9030710423947],
        [106.900418953272, 47.9030968268571],
        [106.900448514887, 47.9031118383407],
        [106.900470759618, 47.903125229246],
        [106.900494697772, 47.9031445466836],
        [106.900534599792, 47.9031851303895],
        [106.900589978245, 47.9032420979445],
        [106.900617361702, 47.9032666638255],
        [106.900656813161, 47.9032951867235],
        [106.900713994755, 47.903330898802],
        [106.900817611044, 47.9033877017811],
        [106.900909906667, 47.9034325024081],
        [106.900957850425, 47.9034516579677],
        [106.901013655156, 47.9034704286174],
        [106.901075257817, 47.90348907606],
        [106.901221698922, 47.9035297478996],
        [106.901375694333, 47.9035759640595],
        [106.901472483868, 47.9036020030301],
        [106.901514925573, 47.9036151088503],
        [106.901555268261, 47.9036303010976],
        [106.901625343435, 47.9036596082044],
        [106.901769002937, 47.9037206254066],
        [106.901862986588, 47.9037556656915],
        [106.901941653884, 47.9037811605722],
        [106.90201955316, 47.9038008907985],
        [106.902197571261, 47.903837879015],
        [106.902387810249, 47.9038834917298],
        [106.902497424117, 47.9039060593172],
        [106.902581224744, 47.9039168619736],
        [106.902701355283, 47.9039295010457],
        [106.90278851218, 47.9039329328586],
        [106.90283341533, 47.9039376372123],
        [106.902872311008, 47.9039437346157],
        [106.902926356666, 47.9039574061094],
        [106.903015347281, 47.9039876916787],
        [106.903076259262, 47.9040092646159],
        [106.903210194395, 47.9040600502312],
        [106.903313096622, 47.9040973568076],
        [106.903434032055, 47.9041319267471],
        [106.90353322278, 47.9041668564154],
        [106.9036064204, 47.9041851504244],
        [106.903690578058, 47.9042056990338],
        [106.903792856155, 47.904225948169],
        [106.903827639234, 47.9042364036871],
        [106.90387728271, 47.9042538073673],
        [106.903934052415, 47.9042760359103],
        [106.904050386017, 47.90432652385],
        [106.904229936562, 47.9043986108073],
        [106.904308095742, 47.9044319738566],
        [106.90438991876, 47.9044710637886],
        [106.904599944632, 47.9045783079426],
        [106.904711603558, 47.9046321278704],
        [106.904780745235, 47.9046630879312],
        [106.904849755612, 47.9046909516261],
        [106.904931571435, 47.9047215438642],
        [106.905011269355, 47.9047497753819],
        [106.905074790269, 47.9047703716554],
        [106.905148031057, 47.9047910092977],
        [106.905257873352, 47.9048185384448],
        [106.905382522985, 47.9048488878659],
        [106.905466328109, 47.904866282553],
        [106.905612187353, 47.9048882448967],
        [106.905710932913, 47.9049109887512],
        [106.905783954266, 47.9049244066361],
        [106.905821318399, 47.9049273042518],
        [106.905863862627, 47.9049279562602],
        [106.905929007718, 47.9049244363138],
        [106.905974765223, 47.9049211411977],
        [106.905997777076, 47.904920857012],
        [106.906041444557, 47.9049250082825],
        [106.906085023905, 47.9049267232897],
        [106.906107659841, 47.9049247933446],
        [106.906128334355, 47.9049211268086],
        [106.906149130278, 47.9049149628553],
        [106.906171286875, 47.9049057825758],
        [106.906186826261, 47.9048966247794],
        [106.906227840742, 47.9048658310933],
        [106.90625924327, 47.9048496702761],
        [106.906288466739, 47.9048380033712],
        [106.906321631938, 47.9048286827975],
        [106.906356788235, 47.9048222382557],
        [106.906392225121, 47.9048188675967],
        [106.906425556694, 47.9048186580547],
        [106.906461690555, 47.9048233048517],
        [106.906527838389, 47.9048389035926],
        [106.906612759571, 47.9048583397406],
        [106.906725421241, 47.9048868275651],
        [106.906866449327, 47.9049252879717],
        [106.907040585954, 47.9049766860253],
        [106.907195015737, 47.9050227978639],
        [106.907282734711, 47.9050531283992],
        [106.907404300568, 47.9051047512833],
        [106.907462385081, 47.9051248079635],
        [106.907631774187, 47.90517656035],
        [106.907697975082, 47.9052003267337],
        [106.90779356582, 47.9052372672861],
        [106.907905615052, 47.9052821497515],
        [106.907977728989, 47.9053146710353],
        [106.90803171709, 47.9053412073309],
        [106.908062786868, 47.9053595858762],
        [106.908091577764, 47.905379951024],
        [106.90810762077, 47.9053954148666],
        [106.908123104398, 47.9054219790411],
        [106.908139123122, 47.9054631652929],
        [106.908142506372, 47.9054828559491],
        [106.90814489677, 47.9055215888503],
        [106.908151299043, 47.905597069849],
        [106.908160070131, 47.9056383757105],
        [106.908170682131, 47.9056625629769],
        [106.908183429122, 47.9056818768172],
        [106.908204445379, 47.9057024910771],
        [106.908235778658, 47.9057248967866],
        [106.908270095888, 47.9057432708353],
        [106.90832799694, 47.9057672539557],
        [106.908372817352, 47.9057828212203],
        [106.908390504318, 47.905790597658],
        [106.908407758711, 47.9058012834026],
        [106.908431445055, 47.9058191772133],
        [106.908491493688, 47.9058742597893],
        [106.908535605434, 47.9059103001203],
        [106.908592304092, 47.9059530493938],
        [106.908666759863, 47.9060054537887],
        [106.90874103577, 47.9060529856568],
        [106.908794198294, 47.906082265784],
        [106.908859340686, 47.9061144147485],
        [106.90898462614, 47.9061684127421],
        [106.909131745334, 47.906224486371],
        [106.909227319885, 47.9062594708979],
        [106.909359226147, 47.9062962909411],
        [106.909611896972, 47.9063627994037],
        [106.90984255509, 47.9064223588049],
        [106.910208385808, 47.9065089284443],
        [106.910460878567, 47.9065705607828],
        [106.910720802423, 47.9066369460383],
        [106.910834230316, 47.9066643178041],
        [106.910886232714, 47.9066734243391],
        [106.910947299378, 47.9066819427175],
        [106.911015729692, 47.9066894259763],
        [106.911081934184, 47.9066943308787],
        [106.911143773367, 47.9066965018421],
        [106.911223458696, 47.9066968507791],
        [106.911301000041, 47.9066947877343],
        [106.911484135285, 47.9066851955654],
        [106.911636380615, 47.9066798122236],
        [106.911730492868, 47.9066786547961],
        [106.911794856448, 47.9066789569683],
        [106.911833920299, 47.9066805910365],
        [106.911945661063, 47.9066949846858],
        [106.912017795685, 47.9067006917836],
        [106.912112115682, 47.90670155873],
        [106.91216878736, 47.9066991854191],
        [106.912213415317, 47.9066949945784],
        [106.91240537201, 47.9066681893855],
        [106.91305555487, 47.908166665859],
        [106.916090573421, 47.9080705580099],
        [106.916361658764, 47.9080666162814],
        [106.916621723814, 47.9080692647848],
        [106.918380983895, 47.9081202824252],
        [106.920062175629, 47.908169081438],
        [106.922466666903, 47.9082337121162],
        [106.923101760038, 47.9082545359182],
        [106.923476268315, 47.9082587483426],
        [106.925690594345, 47.9082425992166],
      ],
    ],
  },
};
